/* eslint-disable react/prop-types */
import { TypingContainer } from 'components';
import { diffChars } from "diff";
// import Axios from '../../services/local/api';
//material ui components
import { Button, Grid, makeStyles, CircularProgress } from '@material-ui/core';
import React, { createRef, useEffect, useRef, useState } from 'react';
//constant

//images
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import './styles.css';
import { useLocation } from 'react-router-dom';
import { baseURLs } from '../../utils/baseURLs';
import TypingTestHeader from './TypingTestHeader';
import TypingTestResultFooter from './TypingTestResult_Footer';
import { useUserContext } from 'UserProvider';
import moodleAxios from '../../services/moodle/moodleApi';
import axios from 'axios';
import Axios from '../../services/local/api';
import { diffWords } from 'diff';
// import axios from 'axios';
// import axiosInstance from 'services/local/users/axiosInstance';
// const { borderRadius } = borders;
// icons styling

const ExerciseTypes = [
  'DrillLines',
  'DrillLinesKeypadTab',
  'DrillLinesKeypadEnter',
  'SentenceTiming',
  'SpeedAccuracyDrill',
  'LocationalReinforcement',
  'ThinkingDrill',
  'ReinforcementDrill',
  'TimedShortDrill',
  'CompositionDrill',
  'ReinforcementDrillKeypadTab',
  'ReinforcementDrillKeypadEnter'
];

let ExerciseResults = '';
let ExerciseResultsArray = [];

const useStyles = makeStyles(theme => ({
  outerDiv: {
    padding: '3px',
    boxShadow: ` 0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%)`,

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.grey[200],
      boxShadow: ` 0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%)`
    }
  },
  button: {
    outline: '0 !important',
    borderRadius: 8,
    backgroundColor: 'white',
    margin: '15px 36px',
    minWidth: '150px',
    fontSize: '18px',
    boxShadow: `0.3rem 0.3rem 0.5rem #c3c1c6, -0.2rem -0.2rem 0.4rem #fff;`,
    color: 'steelblue',
    transition: `all 0.3s ease-in-out`,
    '&:hover': {
      backgroundColor: `#a4a9fc`,
      color: '#fff'
    }
  },
  buttonClick: {
    outline: '0 !important',
    minWidth: '150px',
    borderRadius: 8,
    margin: '15px 36px',
    boxShadow: `inset 0.2rem 0.2rem 0.5rem rgb(195 193 198 / 90%), inset -0.2rem -0.2rem 0.5rem #fff,
    0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem #fff;`,
    backgroundColor: `#fff`,
    color: '#ffffff',
    textShadow: `1px 1px 0 #668fff`,
    cursor: 'not-allowed',
    transition: `all 0.5s ease-in-out`
  }
}));
const getXMLEntities = str => {
  if (typeof str !== 'string') return str;
  switch (str) {
    case '%26':
      return '&amp;';
    case '&':
      return '&amp;';
    case '%3C':
      return '&lt;';
    case '<':
      return '&lt;';
    case '%3E':
      return '&gt;';
    case '>':
      return '&gt;';
    case '%22':
      return '&quot;';
    case '"':
      return '&quot;';
    case '%27':
      return '&apos;';
    case "'":
      return '&apos;';
    default:
      return str;
  }
}

const getCharWiseDiff = (oldStr, newStr) => {
  if (typeof oldStr !== 'string' || typeof newStr !== 'string') return [];
  if (oldStr.includes('\n')) {
    let diff = [];
    const oldLines = oldStr.split('\n');
    const newLines = newStr.split('\n');
    for (let i = 0; i < Math.max(oldLines.length, newLines.length); i++) {
      const oldLine = oldLines[i] || '';
      const newLine = newLines[i] || '';
      const lineDiff = diffChars(oldLine, newLine);
      diff = diff.concat(lineDiff);
    }
    return diff;
  }
  return diffChars(oldStr, newStr);
}

const getKeysStatistics = (oldText, newText, keyData, instanceData) => {
  if (Array.isArray(oldText)) oldText = oldText.join('\n');
  if (Array.isArray(newText)) newText = newText.join('\n');
  const diff = getCharWiseDiff(oldText, newText);
  const keyStats = {};
  for (const part of diff) {
    if (part.value) {
      const chars = part.value.split('');
      for (let char of chars) {
        if (Object.keys(keyData).length > 0 && '0123456789.'.includes(char) && !part.removed) {
          char = keyData.mapping && keyData.mapping[char] ? keyData.mapping[char].pop() : char;
        } else if ('0123456789'.includes(char)) {
          char = `D${char}`;
        }
        if (!keyStats[char]) {
          keyStats[char] = {
            count: 0,
            correctCount: 0,
            incorrectCount: 0
          };
        }
        if (part.added) {
          keyStats[char].count += 1;
          keyStats[char].incorrectCount += 1;
        }
        else if (part.removed) {
          keyStats[char].incorrectCount += 1;
        }
        else {
          keyStats[char].count += 1;
          keyStats[char].correctCount += 1;
        }
      }
    }
  }

  Object.keys(keyData).forEach(char => {
    if (['currentTextLength', 'mapping', '⧗', 'flags'].includes(char)) return;
    if (!keyStats[char]) {
      keyStats[char] = {
        totalTime: 0,
        count: 0,
        correctCount: 0,
        incorrectCount: 0,
        lastTimestamp: null
      };
    }

    if (!keyStats[char].totalTime) keyStats[char].totalTime = 0;
    keyStats[char].totalTime += keyData[char].totalTime || 0;
    keyStats[char].lastTimestamp = keyData[char].lastTimestamp || null;
  });

  Object.keys(keyStats).forEach(char => {
    const stats = keyStats[char];
    const total = stats.correctCount + stats.incorrectCount;
    stats.percentageCorrect = total > 0 ? (stats.correctCount / total) * 100 : 0;
  });

  // return correctCount, incorrectCount, keyStats;
  return keyStats;
};

const TypingTest = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState(false);
  const [demo, setDemo] = useState();
  const [seconds, setSeconds] = useState(0);
  const scrollDiv = createRef();
  const scrollResult = createRef();
  const classes = useStyles();
  const [wordCount, setWordCount] = useState(0);
  const [error, setError] = useState(0);
  const [progress, setProgress] = useState(20);
  const [instanceData, setInstanceData] = useState();
  const [repsData, setRepsData] = useState([]);
  const [showRepsDataValue, setShowRepsDataValue] = useState(0);
  const location = useLocation();
  const [paragraph, setParagraph] = useState('');
  const [allText, setAllText] = useState('');
  const [automaticSubmit, setAutomaticSubmit] = useState(false);
  const [exerciseType, setExerciseType] = useState('');
  const [exerciseTitle, setExerciseTitle] = useState('');
  const [comparison, setComparison] = useState([]);
  const [attemptsRemaining, setAttemptsRemaining] = useState(0);
  const [keyData, setKeyData] = useState({});
  const routes = location.pathname.split('/');
  // const fieldType = location.pathname.split('_')[0];
  const urlId = routes[routes.length - 1].split('%20');
  const InstanceId = urlId[urlId.length - 1].split('-');
  const { userContext } = useUserContext();
  const [counter, setCounter] = useState(0);
  const [setTextLength] = useState();
  const links = location.state;
  const [theresultHTML, setResultHTML] = useState();
  const [theresultHTML2, setResultHTML2] = useState();
  const setCounterTimeoutRefs = useState([])[1];
  const [innitialLineCount, setInnitialLineCount] = useState();
  const [currentDrillIndex, setCurrentDrillIndex] = useState(0);
  useEffect(() => {
    if (theresultHTML?.trim().startsWith('<br>') || theresultHTML?.trim().startsWith('<br>')) {
      setResultHTML(
        theresultHTML
          .replace(/^(<br\s*\/?>\s*)+/i, '')
          .replace(/(\s*<br\s*\/?>)+$/i, '')
          .trim()
      );
    }
    if (theresultHTML2?.trim().startsWith('<br>') || theresultHTML2?.trim().startsWith('<br>')) {
      setResultHTML2(
        theresultHTML2
          .replace(/^(<br\s*\/?>\s*)+/i, '')
          .replace(/(\s*<br\s*\/?>)+$/i, '')
          .trim()
      );
    }
  }, [theresultHTML, theresultHTML2]);
  const [wpmValue, setWpmValue] = useState(0);
  const [errorValueEach, setErrorValueEach] = useState(0);
  const [wpmValueEach, setWpmValueEach] = useState(0);
  const [CounterFlag, setCounterFlag] = useState(false);
  const [secondflag, setSecondflag] = useState(false);
  const [replay, setReplay] = useState(false);
  const [replayClick, setReplayClick] = useState(false);
  const [answers, setAnswers] = useState();

  useEffect(() => {
    if (instanceData?.Activities?.Activity?.attributes?.Type === 'ThinkingDrill') {
      let data = instanceData.Activities.Activity.SubActivityText.TextToType;
      if (data.Text) {
        data = data.Text;
      } else {
        let newData = [];
        data.forEach(item => {
          newData = [...newData, ...(item.Text ?? [])];
        });
        data = newData;
      }
      if (!answers) {
        data = data.map(item => item.replace(/{}/g, '').trim());
        data = data.filter(item => item !== '');
        let seperateAnswers = data.filter(item => item.startsWith('|') && item.endsWith('|'));

        if (seperateAnswers.length > 0) {
          let filteredata = data.filter(item => !item.includes('|'));
          seperateAnswers = seperateAnswers.map(item => item.split('|')[1]);
          setAnswers(seperateAnswers);
          setRepsData(filteredata);
          return;
        }
        const rawPromtText = data.filter(item => item.includes('|'));
        if (data.length === rawPromtText.length) {
          let promptText = rawPromtText.map(item => item.split('|'));
          let ans = promptText.map(item => item.filter((_, i) => i % 2 == 1).join(' '));
          promptText = promptText.map(item => item.filter((_, i) => i % 2 == 0).join(' ___ '));
          setAnswers(ans);
          setRepsData(promptText);
          return;
        }

        let tempAnswers = data.filter((item, index) => index % 2 == 1 || item[1] == '.');
        let suggestions = data
          .filter((item, index) => index % 2 == 0 && item[1] != '.')
          .map(item => item.replace(' ', ', '));
        let tempData = tempAnswers.map((item, index) => {
          let newItem = item
            .split('|')
            .filter((_, i) => i % 2 == 0)
            .join(' ___ ')
            .replace(/{}/g, '');
          tempAnswers[index] = item
            .split('|')
            .filter((_, i) => i % 2 == 1)
            .join(' ');
          newItem += suggestions[index] ? ` (${suggestions[index]})` : '';
          return newItem;
        });
        setAnswers(tempAnswers);
        setRepsData(tempData);
      }
    } else if (['Exercise 7.7:'].includes(instanceData?.Activities?.Activity?.Label)) {
      if (!answers) {
        let data = instanceData.Activities.Activity.SubActivityText.TextToType.Text;
        data = data.filter((_, i) => i % 2 == 0).map(item => item.split('|'));
        let tempData = data.map(item => item.filter((_, i) => i % 2 == 0).join('___'));
        let tempAnswers = data.map(item => item.filter((_, i) => i % 2 == 1).join(' '));
        setAnswers(tempAnswers);
        setRepsData(tempData);
      }
    } else if (typeof repsData === 'string') {
      setRepsData(repsData.split('\n'));
    } else if (repsData.includes('{} {}')) {
      setRepsData(repsData.filter(item => item.trim() !== '{} {}'));
    } else if (repsData.includes('{}')) {
      const temp = repsData.filter(item => item.trim() !== '{}');
      setRepsData(temp.filter((_, index) => index % 2 === 0));
      setAnswers(temp.filter((_, index) => index % 2 !== 0).map(item => item.replace(/\|/g, '')));
    }
  }, [repsData]);

  useEffect(() => {
    let mounted = true;
    const userId = userContext?.userData?.id || localStorage.getItem('userid');
    const fetch = async () => {
      // SJK: CKey-85 : Append userid to Moodle API
      const res = await moodleAxios.get(
        baseURLs.Service_for_KB_data + InstanceId[InstanceId.length - 1] + "&userid=" + (
        localStorage.getItem("userid") || userContext?.userData?.id || ""
        )
      );

      if (mounted) {
        let data = res.data;

        // Update instance data with the modified data object
        setInstanceData(data);
        if (data?.Activities.Activity.attributes.Type === 'Video') {
          setDemo(!!data.Activities.Activity.attributes.Videopath);
        }
        fetchGradedAttemptsRemaining(data?.Activities?.Activity?.attributes?.Id);
        let type = data.Activities.Activity.attributes.Type;
        let title = data.Activities.Activity.Title;
        // console.log(data);
        // console.log(data.Activities.Activity.attributes);

        setExerciseType(() => type);
        setExerciseTitle(() => title);

        if (type && (type === 'TimingKeypadTab' || type === 'TimingKeypadEnter')) {
          const rawText = data.Activities.Activity.SubActivityText?.TextToType.Text;

          // console.log(rawText); // Logs the raw text string

          // Split the rawText by whitespace and rejoin into lines with a fixed number of items per line
          const words = rawText
            .trim()
            .split(/[\n]+/)
            .map(item => item.split('/[ ]+/'));

          const textArray = [];
          for (let i = 0; i < words.length; i++) {
            textArray.push(...words[i]);
          }

          // Create a single concatenated string from the processed lines
          const singleString = textArray.join(' ');

          // Set state variables
          setRepsData(() => textArray); // Array of strings, each representing a line
          setParagraph(() => singleString); // Single concatenated string
        }
        if (type !== 'Document') {
          const textData = res.data.Activities.Activity.SubActivityText?.TextToType;
          let data = [];

          if (type === 'Timing') {
            // Handle Timing type
            for (let key in textData) {
              data.push(textData[key]);
            }
            setParagraph(...data);
            setRepsData(() => data);
          } else {
            // Handle non-Timing type
            if (Array.isArray(textData)) {
              // Case when textData is an array
              textData.forEach(item => {
                if (typeof item.Text === 'string') {
                  data.push(item.Text);
                } else if (Array.isArray(item.Text)) {
                  item.Text.forEach(subText => data.push(subText));
                }
              });
            } else {
              // Case when textData is an object
              for (let key in textData) {
                if (typeof textData[key] === 'string' && textData[key].includes('.xlsx')) {
                  setExerciseType('Timed Short Drill');
                  break;
                }
                if (typeof textData[key] === 'string') {
                  data.push(textData[key]);
                } else if (Array.isArray(textData[key])) {
                  data.push(...textData[key]);
                }
              }
            }
            // console.log(exerciseType);
            // SJK: CKey-86: Revise exerciseType condition to overcome lazy loading
            if (type && (type !== 'TimingKeypadTab') && (type !== 'TimingKeypadEnter')) {
              // Repeat the data based on reps count
              const reps = Number(res.data.Activities.Activity.attributes.Reps);
              /*const repeatedData =
                Number.isInteger(reps) && reps > 0
                  ? Array.from({ length: reps }, () => data).flat()
                  : [];

              repeatedData.forEach(text => {
                setParagraph(prev => prev + ' ' + text);
              });*/
              // SJK: CKey-86: Fix for pattern RepeatEach
              const repsPattern = res.data.Activities.Activity.attributes.Pattern;
              // let repeatedData = [];
              if(repsPattern === "RepeatEach"){
                  const count = Math.max(1, reps || 1);
                  const repeatedData = data.flatMap(text =>
                 text
                    .split('\n')                 // split into lines
                    .flatMap(line =>             // repeat each line
                      Array.from({ length: count }, () => line)
                    )
                );    
                setRepsData(() => repeatedData);
              } else{
                const repeatedData =  Number.isInteger(reps) && reps > 0
                  ? Array.from({ length: reps }, () => data).flat()
                  : [];
                repeatedData.forEach(text => {
                setParagraph(prev => prev + ' ' + text);
                });
                setRepsData(() => repeatedData);
              }
            } else {
              if (type != 'TimingKeypadTab' && type != 'TimingKeypadEnter') {
                const reps = Number(res.data.Activities.Activity.attributes.Reps);
                // console.log(reps);
                const repeatedData =
                  Number.isInteger(reps) && reps > 0
                    ? Array.from({ length: reps }, () => data).flat()
                    : [];

                repeatedData.forEach(text => {
                  setParagraph(prev => prev + ' ' + text);
                });
                setRepsData(() => repeatedData);
              }
            }
          }
        }
      }
    };

    fetch();

    return () => {
      mounted = false;
    };
  }, [InstanceId[1], replay]);
  const fetchGradedAttemptsRemaining = async activityID => {
    const userId = userContext?.userData?.id || localStorage.getItem('userid');
    const courseIDSelected =
      localStorage.getItem('courseIdselected') &&
      localStorage.getItem('courseIdselected') !== 'undefined'
        ? localStorage.getItem('courseIdselected')
        : sessionStorage.getItem('activityInstance');
    try {
      const url = `${process.env.REACT_APP_MOODLE_DEVELOPMENT_URL}/mod/kb/appservice_kbws.php?action=gradedattemptsremaining&userid=${userId}&activityid=${activityID}&id=${courseIDSelected}`;

      const response = await fetch(url);

      const data = await response.json();
      setAttemptsRemaining(data);
      // console.log('Graded Attempts Remaining:', data);
    } catch (error) {
      // console.error('Error fetching graded attempts:', error);
    }
  };
  // useEffect(() => {

  //   fetchGradedAttemptsRemaining();
  // }, [instanceData?.Activities?.Activity?.attributes]);
  const submit = () => {
    if (exerciseType === 'Timing') {
      setAllText(() => text);
      if(!automaticSubmit) {
        setAutomaticSubmit(() => true);
        return;
      }
    }
    comparison.push(text);
    setResult(() => true);

    let filteredRepsData;
    if (answers) {
      filteredRepsData = answers;
    } else if (repsData?.filter(item => item?.includes('{}')).length) {
      filteredRepsData = repsData.map(item => item.split('|')[1]);
    } else {
      filteredRepsData = repsData.map(item => {
        return item
          .replace(/\|/g, '')
          .replace(/^undefined\.\s*/, '')
          .trim();
      });
    }

    if (exerciseTitle.includes('Accuracy') && exerciseType === 'ReinforcementDrill') {
      setAllText(() => text);
      setResult(true);
      //console.log("JG debugging submit0: " + result);
      wordMatch(comparison, filteredRepsData, true);
    } else if (exerciseType === 'Timing') {
      const updatedText = `${text}`.trim(); // Combine existing allText and current text
      setAllText(updatedText); // Update the state with the new value
      //console.log("JG debugging submit1: " + result);
      wordMatch(updatedText?.trim().replace(/\n/g, ' \n '), paragraph.trim(), true);
    } else if (exerciseType === 'DrillLines') {
      //console.log("JG debugging submit2: " + result);
      wordMatchArray(comparison, filteredRepsData);
    } // SJK: CKey-99
    // else if (exerciseType === 'TimingKeypadTab' || exerciseType === 'TimingKeypadEnter'){
       else if (['TimingKeypadTab', 'TimingKeypadEnter', 'ReinforcementDrillKeypadTab', 'ReinforcementDrillKeypadEnter', 'DrillLinesKeypadTab', 'DrillLinesKeypadEnter'].includes(exerciseType)){
      const resultTextXML_TKPTB = generateResultXmlTable_TKPTB(comparison, filteredRepsData);
      allResultTableRowsRef.current.push(resultTextXML_TKPTB);
      const updatedText = `${allText} ${text}`.trim(); // Combine existing allText and current text
      setAllText(updatedText); // Update the state with the new value
      wordMatchArray(comparison, filteredRepsData); // Pass the updated value to wordMatch
    }
    else {
      const updatedText = `${allText} ${text}`.trim(); // Combine existing allText and current text
      setAllText(updatedText); // Update the state with the new value
      //console.log("JG debugging submit3: " + result);
      wordMatchArray(comparison, filteredRepsData); // Pass the updated value to wordMatch
    }
  };
  const submitDrill = (textval, val) => {
    setResult(() => true);
    if (Array.isArray(val)) val = val.join(' ');
    if (typeof textval === 'string') {
      // console.log(val);
      wordMatch(textval?.trim(), val?.trim(), true);
    } else {
      wordMatch(textval?.trim()?.split(' '), val?.trim()?.split(' '), true);
    }
  };

  useEffect(() => {
    if (automaticSubmit) {
      submit();
    }
  }, [automaticSubmit]);

  // useEffect(() => {
  //   if (text.length > 15) {
  //     const tpm = Math.round(text.length / (seconds / 60));
  //     if (tpm > 1000) {
  //       alert('Try to key faster. Click OK and begin keying when you are ready');
  //     }
  //   }
  // });
  // function countWords(str) {
  //   str = str.replace(/(^\s*)|(\s*$)/gi, '');
  //   str = str.replace(/[ ]{2,}/gi, ' ');
  //   str = str.replace(/\n /, '\n');
  //   return str.split(' ').length;
  // }
  // function identifyErrors(text1, para) {
  //   // Convert both arrays into strings, adding a space between each character
  //   const text1String = Array.isArray(text1) ? text1?.join(' ') + ' ' : text1 ?? '';
  //   const paraString = Array.isArray(text1) ? para?.join(' ') + ' ' : para ?? '';

  //   // Trim leading spaces from both strings
  //   const trimmedText1 = text1String?.trimStart();
  //   const trimmedPara = paraString?.trimStart();

  //   let htmlOutput = '';

  //   // Initialize the length of the smaller string to avoid out-of-bounds access
  //   const minLength = Math.min(trimmedText1.length, trimmedPara.length);

  //   // Iterate through the characters
  //   for (let i = 0; i < minLength; i++) {
  //     const textChar = trimmedText1[i] || ''; // Character from text1
  //     const paraChar = trimmedPara[i] || ''; // Character from para

  //     if (textChar === paraChar) {
  //       // Match (including spaces)
  //       htmlOutput += `<span>${paraChar}</span>`;
  //     } else if (textChar !== paraChar) {
  //       // Mismatch - Highlight with a light red background
  //       htmlOutput += `<span style="background-color: lightcoral;">${paraChar}</span>`;
  //     }
  //   }

  //   // Handle any remaining characters in either string as errors
  //   for (let i = minLength; i < trimmedText1.length; i++) {
  //     htmlOutput += `<span style="background-color: lightcoral;">${trimmedText1[i]}</span>`;
  //   }
  //   for (let i = minLength; i < trimmedPara.length; i++) {
  //     htmlOutput += `<span style="background-color: lightcoral;">${trimmedPara[i]}</span>`;
  //   }

  //   return htmlOutput;
  // }

  function aggregateDiff(diff) {
    diff = diff.filter((item, index) => {
      return (
        item.value.trim() !== '' ||
        (item.value.replace(/^[ \t]+|[ \t]+$/g, '') === '\n' &&
          (!item.removed || !diff[index - 1].value.replace(/^[ \t]+|[ \t]+$/g, '').endsWith('\n')))
      );
    });
    diff = diff.map(item => ({
      ...item,
      value: item.value.replace(/ \n/g, '\n').replace(/\n /g, '\n')
    }));
    const result = [];
    let i = 0;

    while (i < diff.length) {
      const current = diff[i];

      if (current.removed) {
        let removedGroup = [current.value];
        let addedGroup = [];
        let j = i + 1;

        while (j < diff.length) {
          const next = diff[j];

          // Stop if an exact match entry comes in between
          if (!next.added && !next.removed) break;

          if (next.added) {
            addedGroup.push(next.value);
          } else if (next.removed) {
            removedGroup.push(next.value);
          }

          j++;
        }

        result.push({
          removed: true,
          value: removedGroup.join(' ')
        });

        if (addedGroup.length > 0) {
          result.push({
            added: true,
            value: addedGroup.join(' ')
          });
        }

        i = j;
      } else if (current.added) {
        // Only process added if not already grouped in previous block
        result.push(current);
        i++;
      } else {
        // Exact match case
        result.push(current);
        i++;
      }
    }

    return result;
  }
  // SJK: CKey-79 : Adjust function to deliver edge cases
  /*function adjustLastWordPartialMatch(diff) {
    let lastRemoved, lastAdded;
    const length = diff.length;
    if (length > 1 && (diff[length - 1].removed || diff[length - 2].removed)) {
      if (diff[length - 1].removed) lastRemoved = diff[length - 1];
      if (diff[length - 2].removed) lastRemoved = diff[length - 2];
      if (diff[length - 1].added) lastAdded = diff[length - 1];
      if (diff[length - 2].added) lastAdded = diff[length - 2];
    }
    if (lastAdded?.value && lastRemoved?.value) {
      let lastWords = lastAdded.value?.split(' '); // preserve \n and tabs
      let lastWord = lastWords[lastWords.length - 1];
      if (lastWord && lastRemoved.value?.includes(lastWord)) {
        let words = lastRemoved.value.split(lastWord);
        const wordsNotTyped = words.slice(1, words.length).join(lastWord);
        const missingWords = words[0];

        if (diff[length - 2].removed) {
          [diff[length - 2], diff[length - 1]] = [diff[length - 1], diff[length - 2]];
        }
        diff = diff.slice(0, diff.length - 2);
        if (lastWords.length > 1) {
          diff.push({ added: true, value: lastWords.slice(0, lastWords.length - 1).join(' ') });
        }
        if (missingWords) diff.push({ removed: true, value: missingWords });
        diff.push({ value: lastWord });
        if (wordsNotTyped) diff.push({ removed: true, value: wordsNotTyped });
      }
    }
    return diff;
  }*/
 function adjustLastWordPartialMatch(diff) {
    let lastRemoved, lastAdded;
    const length = diff.length;
  if (length > 1 && (diff[length - 1].removed || diff[length - 2].removed)) {
      if (diff[length - 1].removed) lastRemoved = diff[length - 1];
      if (diff[length - 2].removed) lastRemoved = diff[length - 2];
      if (diff[length - 1].added) lastAdded = diff[length - 1];
      if (diff[length - 2]?.added) lastAdded = diff[length - 2];
      
    } 
      
for (let i = 0; i < diff.length - 1; i++) {

  const prev = diff[i];
  const curr = diff[i + 1];
  const next = diff[i + 2];

  // =====================================================
  // APOSTROPHE CASE
  // user's -> users
  // =====================================================

  if ( prev?.removed && curr?.value && !curr.added && /^[a-zA-Z]+$/.test(curr.value.trim()) ) {

    const normalize = str =>
      str
        .replace(/'/g, "")
        .replace(/[^\w]/g, "")
        .trim()
        .toLowerCase();

    const removedText = prev.value;

    // -----------------------------------
    // first word from removed block
    // -----------------------------------

    const firstWordMatch = removedText.match(/^(\s*[^\s]+)/);

    if (!firstWordMatch) {
      continue;
    }
    const firstWord = firstWordMatch[1].trim();

    // users === user's
    if (
      normalize(firstWord) === normalize(curr.value)
    ) {
      // -----------------------------------
      // collect remaining removed text
      // -----------------------------------

      let fullRemaining = removedText.slice( firstWordMatch[1].length );
      let consumeUntil = i + 2;

      // merge ALL consecutive removed blocks
      while ( diff[consumeUntil]?.removed ) {
        fullRemaining += diff[consumeUntil].value;
        consumeUntil++;
      }

      // -----------------------------------
      // promote FIRST future common block
      // browser
      // -----------------------------------

      let promotedCommon = null;
      let finalRemaining = fullRemaining;

      for ( let j = consumeUntil; j < diff.length; j++ ) {

        const item = diff[j];

        if ( item?.count && typeof item.value === "string" ) {

          const commonWord = normalize(item.value);
          const trimmed = finalRemaining.trimStart();
          const match = trimmed.match(/^([^\s]+)/);

          if (!match) {
            break;
          }

          const rawWord = match[1];

          // browser. -> browser
          const alphaWord = rawWord.match(/[a-zA-Z]+/)?.[0] || "";

          const cleaned = normalize(alphaWord);

          if (cleaned === commonWord) {

            promotedCommon = {
              count: item.count,
              value: item.value
            };

            // remove ONLY word
            // preserve punctuation
            const wordIndex = finalRemaining.indexOf(alphaWord);

            if (wordIndex !== -1) {

              finalRemaining = finalRemaining.slice( wordIndex + alphaWord.length );
            }

            // merge ALL trailing removed blocks
            let k = j + 1;

            while ( diff[k]?.removed ) {

              finalRemaining +=  diff[k].value;
              k++;
            }

            // remove browser + removed blocks
            diff.splice(j, k - j);
            break;
          }
          break;
        }
      }
      // -----------------------------------
      // detect unexpected added word
      // bro / broser / brow
      // -----------------------------------

      let trailingAdded = null;

      for ( let j = i + 1; j < diff.length; j++) {

        const item = diff[j];

        if ( item?.added && typeof item.value === "string" ) {

          const addedWord = normalize(item.value);

          const browserWord = normalize("browser");

          if ( browserWord.startsWith(addedWord) || addedWord.startsWith("bro") || addedWord !== browserWord) {

            trailingAdded = {
              added: true,
              value: item.value
            };

            // remove original position
            diff.splice(j, 1);

            break;
          }
        }
      }

      // -----------------------------------
      // build replacement
      // -----------------------------------

      const replacement = [

        // users
        {
          added: true,
          value: curr.value
        },

        // user's
        {
          removed: true,
          value: firstWord
        }
      ];

      // browser
      if (promotedCommon) {

        replacement.push( promotedCommon );
      }

      // bro
      if (trailingAdded) {

        replacement.push( trailingAdded );
      }

      // remaining removed text
      if (finalRemaining) {

        replacement.push({
          removed: true,
          value: finalRemaining
        });
      }

      // -----------------------------------
      // replace safely
      // -----------------------------------

      diff.splice(i, consumeUntil - i, ...replacement );
      i--;
    }
  }
}
  if (lastAdded && lastRemoved) {
      let lastWords = lastAdded.value.split(' ');
      let lastWord = lastWords[lastWords.length - 1];

      const normalize = str => str.replace(/'/g, "");
      const escapeRegex = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      const removedText = lastRemoved.value;
      const removedWords = removedText.split(/\s+/);

      const matchWord = removedWords.find(
        w => normalize(w) === normalize(lastWord)
      );

      const isValidLength = lastWord.length > 2;

      //  NEW: strict word-boundary match (prevents plug-in vs plug-ins issue)
      const regex = new RegExp(`\\b${escapeRegex(lastWord)}\\b`);
      const boundaryMatch = removedText.match(regex);

      //  CASE 1: correct match
      if (lastWord && matchWord && boundaryMatch && isValidLength) {
        const index = boundaryMatch.index;

        const missingWords = removedText.slice(0, index);
        const wordsNotTyped = removedText.slice(index + lastWord.length);

        if (diff[length - 2].removed) {
          [diff[length - 2], diff[length - 1]] =
            [diff[length - 1], diff[length - 2]];
        }

        diff = diff.slice(0, diff.length - 2);

        if (lastWords.length > 1) {
          diff.push({
            added: true,
            value: lastWords.slice(0, lastWords.length - 1).join(' ')
          });
        }

        if (missingWords) {
          diff.push({ removed: true, value: missingWords });
        }

        diff.push({ value: lastWord });

        if (wordsNotTyped) {
          diff.push({ removed: true, value: wordsNotTyped });
        }
       // return diff;
      }

      //  CASE 2: WRONG MATCH (e.g., plug-in vs plug-ins)
      else if (matchWord && !boundaryMatch) {
       
        // treat like mismatch instead of splitting incorrectly
        const lastItem = diff[diff.length - 2] || diff[diff.length - 1];

        if (lastItem && lastItem.added) {
          lastItem.error = true;
          delete lastItem.added;
        }

       // return diff;
      }

      //  CASE 3: UNEXPECTED WORD (e.g., mance)
      else {
          const lastItem = diff[diff.length - 1];
          const prevItem = diff[diff.length - 2];

          // DO NOT mark as unexpected if:
          // added word is followed/paired with removed content
          const isPairedReplacement =
            lastItem?.removed &&
            prevItem?.added;

          if (!isPairedReplacement) {

            if (prevItem && prevItem.added) {
              prevItem.error = true;
              delete prevItem.added;
            }

            // optional cleanup
            if (lastItem?.removed) {
              diff.pop();
            }
          }
          console.log(JSON.parse(JSON.stringify(diff)));
          
        //  return diff;
      }
} else if (lastRemoved && !lastAdded) {

  const normalize = str => str.replace(/'/g, "");
  diff = removeDuplicateRemoved(diff);

  for (let i = 0; i < diff.length; i++) {

    const curr = diff[i];
    const next = diff[i + 1];
    const prev = diff[i - 1];

    // =====================================================
    // DETECT ANY WORD ENDING WITH "-" (dynamic)
    // =====================================================
    if ( curr?.value && /[a-zA-Z]+-$/.test(curr.value) && next?.removed ) {  

      const base = curr.value;

      // extract last hyphen word (e.g., "plug-")
      const baseMatch = base.match(/([a-zA-Z]+-)$/);
      if (!baseMatch) continue;

      const baseWord = baseMatch[1]; // "plug-"

      // -------------------------------------------------
      //  STEP 1: collect ALL related removed + next blocks
      // -------------------------------------------------
      let fullRemovedText = next.value;
      let j = i + 2;
      let nextWordPart = "";

      while (j < diff.length) {
        if (diff[j].removed) {
          fullRemovedText += diff[j].value;
        } else if (/^[a-zA-Z]+$/.test(diff[j].value)) {
          nextWordPart = diff[j].value; // e.g. "in"
          // fullRemovedText += diff[j].value;
        } else {
          break;
        }
        j++;
      }

      // -------------------------------------------------
      //  STEP 2: extract FIRST WORD from removed
      // -------------------------------------------------
      const match = fullRemovedText.match(/^([a-zA-Z]+)/);
      if (!match) continue;
      const removedWord = match[1]; // e.g. "ins"
      const typedWord = baseWord + nextWordPart; // "plug-i" or "plug-in"
      
      // -------------------------------------------------
      //  CASE 1: NO CONTINUATION → "plug-"
      // -------------------------------------------------

       if (!nextWordPart) {

                // -----------------------------------------
                // skip already processed nodes
                // -----------------------------------------

                const current = diff[i];

                if (current?.__processed) {
                    continue;
                }

                // -----------------------------------------
                // detect standalone tokenizer hyphen
                // -----------------------------------------

                 // CASE: hyphen wrongly aligned inside removed block
                const hasStandaloneHyphen = diff.some(
                  block =>
                      block.count === 1 &&
                      block.value === "-"
              );

              if (hasStandaloneHyphen) {
                  diff = realignTokenizerDiff(diff);
                   // restart traversal
                  i = -1;
                  continue;
              }

                // -----------------------------------------
                // NORMAL CASE
                // -----------------------------------------

                // first clean removed word
                const removedMatch = fullRemovedText.match(/^([a-zA-Z]+)/);

                const prefixText = curr.value.replace(/([a-zA-Z]+-)$/, "");

                const removedWord = removedMatch?.[1] || "";

                // remaining removed sentence
                const remaining = fullRemovedText.slice(removedWord.length);

                // -----------------------------------------
                // reconstruct proper diff
                // -----------------------------------------

                const replacement = [
                    // existing prefix-text
                    {
                        count: prefixText.length,
                        value: prefixText,
                        __processed: true
                    },

                    // actual typed portion
                    {
                        added: true,
                        value: baseWord,
                        __processed: true
                    },
                    // expected full word
                    {
                        removed: true,
                        value: baseWord,
                        __processed: true
                    },

                    // missing continuation
                    {
                        removed: true,
                        value: removedWord,
                        __processed: true
                    }
                ];

                // preserve remaining sentence
                if (remaining.trim()) {

                    replacement.push({
                        removed: true,
                        value: remaining,
                        __processed: true
                    });
                }

                // -----------------------------------------
                // IMPORTANT:
                // only remove:
                // current block +
                // consecutive removed blocks
                // -----------------------------------------

                const startIndex = i;

                let deleteCount = 1;

                let k = i + 1;

                while (
                    k < diff.length &&
                    diff[k]?.removed
                ) {
                    deleteCount++;
                    k++;
                }

                diff.splice(
                    startIndex,
                    deleteCount,
                    ...replacement
                );

                // -----------------------------------------
                // move cursor safely
                // -----------------------------------------

                i = startIndex + replacement.length - 1;

                continue;
    }   
       
     // -------------------------------------------------
      // CASE 2: WRONG PARTIAL WORD
      // plug-iqwerty
      // feelabc
      // doxyz
      // -------------------------------------------------

      if (!removedWord.startsWith(nextWordPart)) {
            // preserve original count text
            const prefixText =
            base.replace(/([a-zA-Z]+-)$/, "");

            // actual expected full word
            const expectedWord = baseMatch[1] + removedWord;

            // ONLY remaining removed text
            // NEVER prepend typed text
            const remainingRemoved = next.value.slice(removedWord.length);

            diff.splice(i, j - i,

            ...(prefixText
                ? [{
                    count: prefixText.length, value: prefixText
                }]
                : []),

            // removed expected word
            {
                removed: true, value: expectedWord
            },

            // added typed text
            {
                added: true, value: baseMatch[1] + nextWordPart
            },

            // trailing removed text
            ...(remainingRemoved
                ? [{
                    removed: true, value: remainingRemoved
                }]
                : [])
            );

            i--;
            continue;
      }
      
      //  STRICT MATCH CHECK (VERY IMPORTANT)
      const expectedFull = baseWord + removedWord; // "plug-ins"
      const constructed = baseWord + nextWordPart; // "plug-in"

      // -------------------------------------------------
      //  CASE 3: STILL NOT FULL WORD → treat as error
      // (handles plug-i vs plug-in, do vs doing, feel vs feelings)
      // -------------------------------------------------
      if (constructed !== expectedFull.slice(0, constructed.length)) {
        diff.splice(i, j - i,
          { removed: true, value: expectedFull },
          { added: true, value: constructed },
          { removed: true, value: fullRemovedText.slice(removedWord.length) }
        );
        i--;
        continue;
      // return diff;     
      }

      // -------------------------------------------------
      //  CASE 4: PARTIAL MATCH (prefix but incomplete)
      // -------------------------------------------------

    if ((constructed !== expectedFull)) {
      const prefix = base.replace(/[a-zA-Z]+-$/, "");
      const removedOnlyWord = baseMatch[1] + removedWord;

      let remaining = fullRemovedText.slice(removedWord.length);

      let k = j;
      while (diff[k]?.removed) {
        remaining += diff[k].value;
        k++;
      }

      diff.splice(i, k - i,
        ...(prefix ? [{ count: prefix.length, value: prefix }] : []),
        { removed: true, value: removedOnlyWord },
        { added: true, value: constructed },
        ...(remaining ? [{ removed: true, value: remaining }] : [])
      );  
      i--; 
     continue;
    
    // return diff;
    }
      // -------------------------------------------------
      //  CASE 5: NO MATCH (prefix but different word)
      //    plug-inqwerty, plug-qwerty, plug-inssss
      // -------------------------------------------------
        if (typedWord !== expectedFull) {
              const prefix = base.replace(/[a-zA-Z]+-$/, "");
              const removedOnlyWord = baseMatch[1] + removedWord;
              // expected word
              const expected = removedWord;
              // extra typed content
              let extraTyped = "";

              // Example:
              // expected = "in"
              // typedWord = "inqwerty"
              if (typedWord.startsWith(expected)) {
                extraTyped = typedWord.slice(expected.length);
              }

              let remaining = "";

              let k = j;
              while (diff[k]?.removed) {
                remaining += diff[k].value;
                k++;
              }

              diff.splice( i, k - i,
                ...(prefix
                  ? [{ count: prefix.length, value: prefix }]
                  : []),

                // plug-
                {
                  removed: true, value: removedOnlyWord
                },

                // inqwerty extra part
                ...(extraTyped
                  ? [{
                      added: true, value: expected + extraTyped
                    }]
                  : [{
                      added: true, value: typedWord
                    }]),

                ...(remaining
                  ? [{
                      removed: true, value: remaining
                    }]
                  : [])
              );
              i--;
              continue;            
      }

      // -------------------------------------------------
      //  CASE 5: VALID BROKEN DIFF → MERGE
      // -------------------------------------------------
      const missingPart = removedWord.slice(nextWordPart.length);
      const remainingText = fullRemovedText.slice(removedWord.length);
      // build final removed text
      let finalRemoved = (missingPart + remainingText)
        .replace(/([a-zA-Z]+)-\s+([a-zA-Z]+)/g, "$1-$2")
        .trimStart();

      // merge visible text
      const fixedValue = base.replace(
        /([a-zA-Z]+-)$/,
        `$1${nextWordPart}`
      );

      // IMPORTANT:
      // remove ALL consumed nodes including trailing removed block
      // otherwise duplicate removed blocks survive
      const deleteCount = (j - i) + 1;

      // replace section safely
      diff.splice(
        i,
        deleteCount,
        {
          count: fixedValue.length, value: fixedValue
        },
        {
          removed: true, value: finalRemoved
        }
      );
      i--;
      continue;

    }
  
    // =====================================================
    //  GENERIC PARTIAL WORD CASE (do vs doing, feel vs feelings)
    // =====================================================
    if (
      curr?.value &&
      next?.removed &&
      /^[a-zA-Z]+$/.test(curr.value)
    ) {
    // =====================================================
    // CASE 1A: DUPLICATE WORD
    // Example:
    // [count "add a plug-in to "]
    // [value "to"]
    // [removed "the user's browser"]
    // =====================================================
    const prev = diff[i-2];
    if (
      prev?.value && 
      curr?.value &&
      next?.removed
    ) {
     
      const getLastWord = str => {
        const words = str.trim().split(/\s+/);
        return words[words.length - 1] || "";
      };

      const normalize = str =>
      str.replace(/'/g, "").toLowerCase();

      const prevLastWord = getLastWord(prev.value);
      const currentWord = curr.value.trim();
      const typedWord = curr.value.trim();

      // first expected word from removed block
      const expectedMatch = next.value.trim().match(/^([^\s]+)/);
      const expectedWord = expectedMatch
        ? expectedMatch[1]
        : "";


      if ( prevLastWord && currentWord && (normalize(prevLastWord) === normalize(currentWord) )
      ) {
        // prepend current word to removed block
         const fullRemoved = curr.value + next.value;
        diff.splice(
        i,
        2,
        {
          added: true, value: currentWord
        },
        {
          removed: true, value: fullRemoved
        }
      );
      
        // =====================================================
        // MERGE removed blocks + fix duplicate "to"
        // 
        // FROM:
        // [removed "add a plug-in "]
        // [added "to"]
        // [removed "toto the user's browser..."]
        //
        // TO:
        // [added "to"]
        // [removed "add a plug-in to the user's browser..."]
        // =====================================================
       

        for (let i = 0; i < diff.length - 3; i++) {
          const first = diff[i];
          const second = diff[i + 1];
          const third = diff[i + 2];
          const fourth = diff[i + 3];

          if (
            first?.value &&
            second?.removed &&
            third?.added &&
            fourth?.removed
          ) {
            let removedStart = second.value || "";
            let addedWord = third.value.trim(); // "to"
            let removedEnd = fourth.value || "";

            // remove duplicate start like "toto", "thethe", etc.
            const normalize = str =>
              str.replace(/'/g, "").toLowerCase();

            const repeatedWordRegex = new RegExp(
              `^(${addedWord})\\1\\b`,
              "i"
            );

            // Example:
            // "toto the user's browser"
            // → "to the user's browser"
            removedEnd = removedEnd.replace( repeatedWordRegex, addedWord);

            const mergedRemoved = removedStart + removedEnd;

            diff.splice( i + 1, 3,
              {
                added: true, value: addedWord
              },
              {
                removed: true, value: mergedRemoved
              }
            );
           // return diff;         
          }
        }
        i--;
       continue;

       // return diff;
      } else {
        
        diff = handleWrongPartialMatch(diff);
      }
    } else {

     // existing logic continues
     diff = handleWrongPartialMatch(diff); }
    }
    // 
  }
  return diff;
  }
    return diff;
}
function realignTokenizerDiff(diff) {

    const result = [];

    const isEqual = block =>
        block &&
        block.count &&
        !block.removed &&
        !block.added;

    for (let i = 0; i < diff.length; i++) {

        const curr = diff[i];
        const next = diff[i + 1];
        const next2 = diff[i + 2];

        /*
        ==================================================
        DETECT:
            removed
            equal "-"
            removed
        ==================================================
        */

        if (
            curr?.removed &&
            isEqual(next) &&
            next.value === "-" &&
            next2?.removed
        ) {

            /*
            ----------------------------------------------
            reconstruct full phrase
            ----------------------------------------------
            */

            const rebuilt =
                curr.value +
                "-" +
                next2.value;

            /*
            ----------------------------------------------
            extract FIRST hyphenated occurrence ONLY
            ----------------------------------------------
            */

           const match =
              rebuilt.match(
                  /(\s*(?:\S+\s+){0,2}\S+-\S+(?:\s+\S+){0,1}\s*)/
              );

          const stable = match[1];

          const before =
              rebuilt.slice(
                  0,
                  rebuilt.indexOf(stable)
              );

          if (before.trim()) {

              result.push({
                  removed: true,
                  value: before
              });
          }

          result.push({
              added: true,
              value: "-"
          });

          result.push({
              count:
                  stable.trim().split(/\s+/).length,
              value: stable
          });

            /*
            ----------------------------------------------
            remaining text
            ----------------------------------------------
            */

            let removedText =
                rebuilt.slice(
                    rebuilt.indexOf(stable) +
                    stable.length
                );

            let consumeUntil = i + 2;

            /*
            collect ONLY consecutive
            equal/removed blocks
            */

            for (let j = i + 3; j < diff.length; j++) {

                const block = diff[j];

                if (block.added) {
                    break;
                }

                if (
                    block.removed ||
                    isEqual(block)
                ) {

                    removedText += block.value;
                    consumeUntil = j;
                }
                else {
                    break;
                }
            }

            /*
            ----------------------------------------------
            collapse all remaining into removed
            ----------------------------------------------
            */

            if (removedText.trim()) {
              removedText = removedText.replace(/^\s+/, "");
                result.push({
                    removed: true,
                    value: removedText
                });
            }

            i = consumeUntil;

            continue;
        }

        result.push(curr);
    }

    return result;
}
function removeDuplicateRemoved(diff) {
  const result = [];

  for (let i = 0; i < diff.length; i++) {
    const curr = diff[i];
    const prev = result[result.length - 1];

    if (
      curr?.removed &&
      prev?.removed &&
      curr.value === prev.value
    ) {
      // skip duplicate
      continue;
    }

    result.push(curr);
  }

  return result;
}
function handleWrongPartialMatch(diff) {

  for (let i = 0; i < diff.length - 1; i++) {

    const prev = diff[i];
    const curr = diff[i + 1];

    if (
      prev?.removed &&
      curr?.value &&
      /^[a-zA-Z]+$/.test(curr.value)
    ) {

      const removedText = prev.value;

      //  allow leading spaces
      const match = removedText.match(/^\s*([a-zA-Z'-]+)/);
      if (!match) continue;

      const firstWord = match[1];   // "doing"
      const typedWord = curr.value; // "do"

      // PREFIX MATCH → WRONG (do vs doing, feel vs feelings)
      if (
        firstWord.startsWith(typedWord) &&
        firstWord !== typedWord
      ) {

        // console.log("WRONG PARTIAL MATCH:", typedWord, "≠", firstWord);

        // remaining after first word
        let remaining = removedText.slice(match[0].length);

        // merge further removed blocks
        let j = i + 2;
        while (diff[j]?.removed) {
          remaining += diff[j].value;
          j++;
        }

        // replace nodes
        diff.splice(i, j - i,
          { removed: true, value: firstWord },
          { added: true, value: typedWord },
          { removed: true, value: remaining }
        );

        // IMPORTANT: move index forward
        i += 2;

        continue; // process next occurrences
      }
    }
  }

  return diff;
}

  function adjustForTimingActivities(text1, para) {
    if (instanceData.Activities.Activity.attributes.Type !== 'Timing') return [text1, para];
    if (typeof text1 !== 'string' || typeof para !== 'string') throw new Error ('Both parameters accepts only string value.');
    const text1Lines = text1.split('\n');
    const paraLines = para.split('\n');
    if (para.includes('\n') && text1Lines.length < paraLines.length) {
      const linesToAdd = paraLines.length - text1Lines.length;
      let linesAdded = 0;
      while (linesAdded < linesToAdd) {
        text1Lines.push(text1Lines[linesAdded++ % text1Lines]);
      }
    }
    return [text1Lines.join('\n'), paraLines.join('\n')];
  }

  // SJK : CKey-79 to fix single char in diff : Enhancements to edge cases
  /*function fixPartialWordDiff(diff, userTyped, originalText) {
  for (let i = 0; i < diff.length; i++) {
    const item = diff[i];
    if (!item.removed && !item.added && item.count === 1 && item.value.length === 1) {
      const char = item.value;
      const next = diff[i + 1];
      const prev = diff[i - 1];
      const curr = diff[i];
      if (prev && prev.removed) {
        const removedText = prev.value.trim();
        const firstWord = removedText.split(/\s+/)[0];
        if (firstWord.startsWith(char)) {
          diff[i-2].value = diff[i-2].value + char;
          next.value = prev.value + next.value;
          curr.value = next.value.replace(char, "");
          diff.splice(i-1,i+1);
          if(curr.value.length > 1){
            diff.push({ removed: true, value: curr.value });
          }
        }
      }
    }
  }
  return diff;
}*/
  function fixPartialWordDiff(diff, userTyped, originalText) {
  for (let i = 0; i < diff.length; i++) {
    const item = diff[i];
      const char = item.value;
      const next = diff[i + 1];
      const prev = diff[i - 1];
      const curr = diff[i];
    if (!item.removed && !item.added && item.count === 1 && item.value.length === 1) {
      if (prev && prev.removed) {
        const removedText = prev.value.trim();
        const firstWord = removedText.split(/\s+/)[0];
        if (firstWord.startsWith(char)) {
          diff[i-2].value = diff[i-2].value + char;
          next.value = prev.value + next.value;
          curr.value = next.value.replace(char, "");
          diff.splice(i-1,i+1);
          if(curr.value.length > 1){
            diff.push({ removed: true, value: curr.value });
          }
        }
        else{
          return adjustLastWordPartialMatch(diff);
        }
      }
    } else{
        if (prev && curr) {
          const normalize = str => str.replace(/'/g, "");
          const removedText = prev.value.trim();
          // if (!removedText) return; // or continue
          const firstWord = removedText.split(/\s+/)[0];
          if (
          normalize(curr.value.trim()).startsWith(
            normalize(firstWord)
          )
        ) {
            const removedText = prev.value;
            const typedWord = curr.value.trim();
            const normalize = str => str.replace(/'/g, "");

            // Step 1: extract first word from removed
            const removedWords = removedText.trim().split(/\s+/);
            const originalWord = removedWords[0];

            // Step 2: validate match (users vs user's)
            if (normalize(typedWord) !== normalize(originalWord)) {
              // return diff;
              continue;
            }

            // Step 3: split removed text after first word
            const restOfRemoved = removedText.slice(originalWord.length);

            // Step 4: try to merge next "browser"
            let next = diff[i + 2]; // skip middle removed
            let browserText = "";

            if (next && next.value && !next.removed && !next.added) {
              browserText = next.value;
            }

            // Step 5: build new diff
            let newDiff = [];

            // keep everything before prev
            for (let k = 0; k < i - 1; k++) {
              newDiff.push(diff[k]);
            }

            // removed: "user's"
            newDiff.push({
              removed: true,
              value: originalWord
            });

            // added: "users"
            newDiff.push({
              added: true,
              value: typedWord
            });

            // unchanged: " browser."
            newDiff.push({
              count: (browserText + restOfRemoved.split(/\s+/)[0]).length,
              value: browserText + restOfRemoved.split(/\s+/)[0]
            });

            // Step 6: rebuild remaining removed text
            const remainingText =
              restOfRemoved.slice(restOfRemoved.indexOf(browserText) + browserText.length) +
              diff.slice(i + 1).map(d => d.value || "").join("");

            if (remainingText.trim()) {
              newDiff.push({
                removed: true,
                value: remainingText.trim()
              });
            }

            return newDiff;
          }
        }   
    }
  }
  return diff;
}
  function applyFixOnlyIfSingleCharExists(diff, userTyped, originalText) {
  const hasSingleChar = diff.some(
    item =>
      (!item.added && !item.removed) &&
      item.value &&
      item.value.length === 1 &&
      (!item.count || item.count === 1)
  );
  return hasSingleChar
    ? fixPartialWordDiff(diff, userTyped, originalText)
    : adjustLastWordPartialMatch(diff);
}

  function formatErrors(text1, para, mimicOldBehaviour = false) {
    if (Array.isArray(text1)) text1 = text1.join(' ');
    if (Array.isArray(para)) para = para.join(' ');
    //[text1, para] = adjustForTimingActivities(text1, para);
    let iterations;
    if (
      ['TimedShortDrill', 'Timing'].includes(instanceData.Activities.Activity.attributes.Type) &&
      (text1?.includes('\n') || para?.includes('\n'))
    ) {
      const extractLines = text => text?.split('\n').map(item => item.trim()) ?? [];
      const compairisionData = [[...extractLines(text1)], [...extractLines(para)]];
      iterations = Math.max(compairisionData[0].length, compairisionData[1].length);
      if (iterations > 1) {
        let [htmlOutput, formatedreference, err] = [[], [], 0];
        for (let i = 0; i < iterations; i++) {
          const data = [compairisionData[0][i], compairisionData[1][i]];
          let mimicOldBehaviour = iterations - 1 === i;
          mimicOldBehaviour = mimicOldBehaviour || i >= compairisionData[0].length - 1;
          // SJK: CKey-80: Patch to reassign data for first paragraph for second iteration
          if(data[1] === undefined && (data[0] !== undefined && data[0] !== null)){
            data[1] = compairisionData[1][0];
          }
          /////////////////////////
          const compairision = formatErrors(data[0] ?? '', data[1] ?? '', mimicOldBehaviour);
          htmlOutput.push(compairision[0]);
          formatedreference.push(compairision[1]);
          err += compairision[2];
        }
        htmlOutput = htmlOutput.join('<br>');
        ExerciseResults = htmlOutput;
        formatedreference = formatedreference.slice(0, innitialLineCount).join('<br>');
        return [htmlOutput, formatedreference, err];
      }
    }

    mimicOldBehaviour =
      !['TimedShortDrill', 'Timing'].includes(instanceData.Activities.Activity.attributes.Type) ||
      mimicOldBehaviour;
    let diff = diffWords(para ?? '', text1 ?? '');
    diff = aggregateDiff(diff);
    let addAtLast = '';
    if (['TimedShortDrill', 'Timing'].includes(instanceData.Activities.Activity.attributes.Type)) {
      if (diff.length === 1 && diff[0].removed && mimicOldBehaviour) {
        addAtLast += `<span ${
          instanceData.Activities.Activity.attributes.Type != 'CompositionDrill'
            ? 'style="color: red; background-color: rgb(254, 196, 192);"'
            : ''
        }>${diff[0].value}</span>`;
        diff = [];
      } else if (diff.length > 1 && mimicOldBehaviour) {
        // diff = adjustLastWordPartialMatch(diff);
        // SJK: CKey-79 - Cross check for any single char in diff and revise diff accordingly
        if(instanceData.Activities.Activity.attributes.Type === 'Timing')
        {
          const hasSingleChar = diff.some(
            item =>
              (!item.added && !item.removed) &&
              item.value &&
              item.value.length === 1 &&
              (!item.count || item.count === 1)
          );
          if(hasSingleChar){
            diff = applyFixOnlyIfSingleCharExists(diff, text1 ?? '', para ?? '');
          } else{
            diff = adjustLastWordPartialMatch(diff);
          }
        } else{
        diff = adjustLastWordPartialMatch(diff);
        }
      }
    }
    let err2 = 0;
    // Fast path: Only calculate error count, skip formatting
    if (instanceData.Activities.Activity.attributes.DisplayErrors === '0') {

      // If diff has more than one element, slice as in the original logic
      const isLatMatched =
        diff.length > 1 && !(diff[diff.length - 1].removed || diff[diff.length - 1].added);
      if (!isLatMatched && diff.length > 1 && mimicOldBehaviour) {
        if (diff[diff.length - 1].removed) {
          diff = diff.slice(0, diff.length - 1);
        } else if (diff[diff.length - 2]?.removed) {
          diff = [...diff.slice(0, diff.length - 2), diff[diff.length - 1]];
        }
      }
      for (let i = 0; i < diff.length; i++) {
        if (diff[i].removed) {
          err2 += diff[i].value?.trim().replace('\t', '').split(' ').length;
        }
        const hasPrevRemoved = i > 0 ? diff[i - 1].removed : false;
        const hasNextRemoved = i < diff.length - 1 ? diff[i + 1].removed : false;
        const isCurrentAdded = diff[i].added;
        if (!hasPrevRemoved && !hasNextRemoved && isCurrentAdded) {
          err2 += diff[i].value?.trim().replace('\t', '').split(' ').length;
        }
      }
      if (Array.isArray(text1)){
        text1 = text1.map(item => item.replace(/\n/g, '<br>'));
      } else {
        text1 = text1.replace(/\n/g, '<br>');
      }

      if (Array.isArray(text1)){
        para = para.map(item => item.replace(/\n/g, '<br>'));
      } else {
        para = para.replace(/\n/g, '<br>');
      }      
    }

    // --- Otherwise, do the full formatting as before ---

    let htmlOutput = '';
    let formatedreference = '';
    if (diff.length > 1 && mimicOldBehaviour) {
      if (diff[diff.length - 1].removed) {
        addAtLast += `<span ${
          instanceData.Activities.Activity.attributes.Type != 'CompositionDrill'
            ? 'style="color: red; background-color: rgb(254, 196, 192);"'
            : ''
        }>${diff[diff.length - 1].value}</span>`;
        diff = diff.slice(0, diff.length - 1);
      } else if (diff[diff.length - 2] && diff[diff.length - 2].removed) {
        addAtLast += `<span ${
          instanceData.Activities.Activity.attributes.Type != 'CompositionDrill'
            ? 'style="color: red; background-color: rgb(254, 196, 192);"'
            : ''
        }>${diff[diff.length - 2].value}</span>`;
        diff = [...diff.slice(0, diff.length - 2), diff[diff.length - 1]];
      }
    }

    let err = 0;
    for (let i = 0; i < diff.length; i++) {
      if (diff[i].added) {
        htmlOutput += `<span ${
          instanceData.Activities.Activity.attributes.Type != 'CompositionDrill'
            ? 'style="color: red; background-color: rgb(254, 196, 192);"'
            : ''
        }>${diff[i].value}</span>`;
        if (diff[i].value === '\n') {
          formatedreference += `<span>${diff[i].value}</span>`;
        }
      } else if (diff[i].removed) {
        err += diff[i].value?.trim().replace('\t', '').split(' ').length;
        formatedreference += `<span>${diff[i].value} </span>`;
        htmlOutput += `<span ${
          instanceData.Activities.Activity.attributes.Type != 'CompositionDrill'
            ? 'style="color: green; background-color: rgb(181, 239, 219);"'
            : ''
        }>${diff[i].value}</span>`;
      } else {
        formatedreference += `<span>${diff[i].value}</span>`;
        htmlOutput += `<span> ${diff[i].value}</span>`;
      }

      const hasPrevRemoved = i > 0 ? diff[i - 1].removed : false;
      const hasNextRemoved = i < diff.length - 1 ? diff[i + 1].removed : false;
      const isCurrentAdded = diff[i].added;
      if (!hasPrevRemoved && !hasNextRemoved && isCurrentAdded) {
        err += diff[i].value?.trim().replace('\t', '').split(' ').length;
      }
    }
    // if (diff.length > 0 && diff[diff.length - 1].added && mimicOldBehaviour) {
    //   err += diff[diff.length - 1].value?.trim().replace('\t', '').split(' ').length;
    // }

    formatedreference +=
      (addAtLast.length > 0 && formatedreference.length > 0 ? ' ' : '') + addAtLast;

    htmlOutput = htmlOutput.replace(/\n/g, '<br>');
    formatedreference = formatedreference.replace(/\n/g, '<br>');
    ExerciseResults = htmlOutput;
    if (instanceData.Activities.Activity.attributes.DisplayErrors === '0') {
      return [
        Array.isArray(text1) ? text1.join('<br>') : text1,
        Array.isArray(para) ? para.join('<br>') : para,
        err2
      ];
    }
    return [htmlOutput, formatedreference, err];
  }

  // function formatResult(text1, para) {
  //   let htmlOutput = '';
  //   if (Array.isArray(text1)) text1 = text1.join(' ');
  //   if (Array.isArray(para)) para = para.join(' ');
  //   let diff = diffWords(para ?? '', text1 ?? '');
  //   // Added means new text content some extra text.
  //   // Removed means The text not present but it is ment to be present.
  //   // Not added and not removed means the text we expected is present.
  //   for (let i = 0; i < diff.length; i++) {
  //     if (diff[i].removed) {
  //       htmlOutput += `<span style="color: red; background-color: rgb(254, 196, 192);">${diff[i].value}</span>`;
  //     } else if (!diff[i].added) {
  //       htmlOutput += `<span>${diff[i].value}</span>`;
  //     }
  //   }
  //   return htmlOutput;
  // }

  // Helper function to check for wrong words
  function isWrongWord(word1, word2) {
    if (word1.length !== word2.length) {
      return false;
    }

    let mismatchCount = 0;
    for (let i = 0; i < word1.length; i++) {
      if (word1[i] !== word2[i]) {
        mismatchCount++;
      }
      if (mismatchCount > 1) {
        return false;
      }
    }
    return mismatchCount === 1;
  }

  // Helper function to check for duplicate words
  function isDuplicateWord(words, index) {
    return index > 0 && words[index] === words[index - 1];
  }

  // Helper function to check for number errors
  function isNumberError(word1, word2 = '') {
    const numberRegex = /\d+/;
    return numberRegex.test(word1) || numberRegex.test(word2);
  }

  // Helper function to check for punctuation errors
  function isPunctuationError(word1, word2 = '') {
    const punctuationRegex = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
    return punctuationRegex.test(word1) || punctuationRegex.test(word2);
  }

  // Helper function to check for capitalization errors
  function isCapitalizationError(word1, word2) {
    return word1.toLowerCase() === word2.toLowerCase() && word1 !== word2;
  }

  const generateKeysXML = keyStats => {
    return Object.entries(keyStats)
      .map(([char, stats]) => {
        const avgTime = stats.totalTime / stats.count || 0;

        return `
            <Key>
                <AverageTime>${Number.isFinite(avgTime) ? avgTime : 0}</AverageTime>
                <Char>${getXMLEntities(char)}</Char>
                <PercentCorrect>${stats.percentageCorrect.toFixed(2)}</PercentCorrect>
                <Count>${stats.count}</Count>
            </Key>
        `;
      })
      .join('');
  };
  // eslint-disable-next-line no-unused-vars
  function generateResultTextTable(typedLines, referenceLines) {
    if (Array.isArray(typedLines)) typedLines = typedLines.join(' ');
    if (Array.isArray(referenceLines)) referenceLines = referenceLines.join(' ');
    const typedWords = typedLines?.trim().split(/\s+/) ?? '';
    const referenceWords = referenceLines?.trim().split(/\s+/) ?? '';
    const cells = [];

    for (let i = 0; i < Math.max(typedWords.length, referenceWords.length); i++) {
      const typedWord = typedWords[i] || '';
      const referenceWord = referenceWords[i] || '';
      const cellClass = typedWord === referenceWord ? 'correct' : 'incorrect';
      cells.push(`<td class="${cellClass}">${typedWord}</td>`);
    }

    const rows = [];
    const maxCellsPerRow = 12;

    for (let i = 0; i < cells.length; i += maxCellsPerRow) {
      const rowCells = cells.slice(i, i + maxCellsPerRow).join('');
      rows.push(`<tr>\n\t${rowCells}</tr>`);
    }

    return rows.join('\n');
  }

  // SJK: CKey-99
  function generateResultXmlTable_TKPTB(userTyped, reference) {
  const rows = [];
  const rowCount = Math.max(userTyped.length, reference.length);
  for (let r = 0; r < rowCount; r++) {
    const typedRow = userTyped[r] ?? '';
    const refRow = reference[r] ?? '';

    const typedCells = typedRow.split(/\s+/);
    const refCells = refRow.split(/\s+/);

    const maxLen = Math.max(typedCells.length, refCells.length);
    const currentRow = [];

    for (let c = 0; c < maxLen; c++) {
      const typedRaw = typedCells[c] ?? '';
      const refRaw = refCells[c] ?? '';

      const typedWord = typedRaw.replace(/⧗+/g, '').trim();
      const referenceWord = refRaw.trim();

      const isEmpty = typedRaw.includes('⧗⧗');
      // SJK: CKey-99: Revise code for table to display the data with inline style
      /* const cellClass = typedWord === referenceWord ? 'correct' : 'incorrect';

      currentRow.push(
        `<td class="${cellClass}">${typedWord}</td>`
      ); 
      const cellClass = referenceWord.startsWith(typedWord) ? '' : 'color: red';
      currentRow.push(
        `<td style="${cellClass}">${typedWord}</td>`
      ); */
      const is_partial = isPartialOfTarget(userTyped, reference, r, c, typedWord.trim(), referenceWord)
      const cellClass =  ((typedWord != referenceWord) && (!is_partial))? 'text-decoration: line-through; color: red' : '';
      currentRow.push(
        `<td style="${cellClass}">${typedWord}</td>`
      );
    }
    rows.push(`<tr>\n\t${currentRow.join('')}\n</tr>`);  
    }
    return rows.join('\n');
  }

  const allResultTableRowsRef = useRef([]);
  const wordMatch = async (text1, para, isSubmit = false) => {
    // SJK : CKey-99
    if (instanceData?.Activities.Activity.attributes.Type === 'TimingKeypadTab' || instanceData?.Activities.Activity.attributes.Type === 'TimingKeypadEnter') {
      if(!isSubmit) return;
    }
    const resultTextXML = generateResultTextTable(text1, para);
    allResultTableRowsRef.current.push(resultTextXML);
    let matches = 0;
    let totalErrors = 0;
    if (typeof text1 === 'string') text1 = [text1];
    text1 = Array.isArray(text1) ? text1.filter(line => line == '\n' || line.trim() !== '') : [];

    // Calculate word count correctly (ignore empty words)
    let wordCount = text1
      .join(' ')
      .replace(/\n/g, ' ')
      .replace(/^[ ]+|[ ]+$/g, '')
      .replace(/ {2,}/g, ' ')
      .split(' ').length;
    let formattedText = [];
    let resultHTML = [];

    // console.log(`\n------------------------------------------------------------\n`);

    for (let lineIndex = 0; lineIndex < Math.max(text1?.length, para?.length); lineIndex++) {
      const line1 = text1[lineIndex]?.trim()?.split(' ') || [];
      const line2 = para[lineIndex]?.trim()?.split(' ') || [];
      let lineMatches = 0;

      let i = 0,
        j = 0;
      while (i < line1.length || j < line2.length) {
        const word1 = line1[i] || '';
        const word2 = line2[j] || '';

        if (word1 === word2) {
          lineMatches++;
        }

        i++;
        j++;
      }

      matches += lineMatches;
    }
    const isCompositionDrill =
      instanceData?.Activities.Activity.attributes.Type === 'CompositionDrill';
    // if (isCompositionDrill) {
    //   formattedText = text1;
    // }

    // let tempPara = para;
    // let temptext1 = text1;
    // if (Array.isArray(tempPara)) tempPara = tempPara.join(' ');
    // if (Array.isArray(temptext1)) temptext1 = temptext1.join(' ');
    // let diff = diffChars(tempPara, temptext1);
    // let finalMatchedindex;
    // diff = diff.filter(item => {
    //   if (!item.added && !item.removed && item.value.trim() !== '') {
    //     finalMatchedindex = diff.find(itemInner => itemInner.value === item.value);
    //   }
    //   return item.value.trim() !== '';
    // });

    // totalErrors = 0;
    // if (diff.length && finalMatchedindex && finalMatchedindex < diff.length - 1) {
    //   for (let i = finalMatchedindex + 1; i < diff.length; i++) {
    //     if (diff[i].added) {
    //       totalErrors += diff[i].value.trim().split(' ').length;
    //     }
    //   }
    // }
    // for (let itemIndex = 0; itemIndex < diff.length; itemIndex++) {
    //   const item = diff[itemIndex];
    //   const incorrect = item.removed;
    //   const words = item.value.trim().split(' ').length;
    //   totalErrors += incorrect ? words : 0;
    // }
    [formattedText, resultHTML, totalErrors] = formatErrors(text1, para, !text1?.includes('\n'));
    formattedText = [
      formattedText.length
        ? formattedText
        : instanceData.Activities.Activity.attributes.Type.startsWith('Timing')
        ? ' '
        : ''
    ];
    resultHTML = [resultHTML.length ? resultHTML : para];

    if (exerciseType === 'Timing') {
      const cleanedResultHTML = resultHTML.map(item => item.replace(/&#x2191;/g, ''));
      const cleanedFormattedText = formattedText.filter(
        item => item !== '<span style="color: red;">&#x2191;</span>'
      );

      setResultHTML(cleanedResultHTML.join(' '));
      setResultHTML2(cleanedFormattedText.join(' '));
    } else {
      setResultHTML(resultHTML.join(isCompositionDrill ? ' ' : '<br>'));
      setResultHTML2(formattedText.join(isCompositionDrill ? ' ' : '<br>'));
    }
    let wam = 1;
    if (exerciseType === 'Timing') {
      wam = Math.round(wordCount / (Number(TimeLimit) / 60));
    } else {
      wam = Math.round(wordCount / ((seconds + 1) / 60));
    }

    const percentageCorrectness = (matches / (wordCount === 0 ? 1 : wordCount)) * 100;

    setErrorValueEach(totalErrors);
    setWpmValueEach(wam);
    setWpmValue(wam);

    if (exerciseType === 'TimingKeypadTab' || exerciseType === 'TimingKeypadEnter') {
      setError(totalErrors);
      setWordCount(wordCount);
      return;
    } else {
      //console.log("JG Debug");
      //console.log(result);
      //console.log(exerciseType);
      //console.log(isSubmit);
      if (isSubmit || result || exerciseType === 'Timed Short Drill' ||  exerciseType === 'CompositionDrill') {
        const userId = userContext?.userData?.id || localStorage.getItem('userid');
        const userName = userContext?.userData?.fullname || localStorage.getItem('username');
        const userEmail = userContext?.userData?.email || localStorage.getItem('userEmail');
        text1 = Array.isArray(text1) ? text1 : [];
        sendDataToMood(
          userId,
          InstanceId[InstanceId?.length - 1],
          wam,
          exerciseType === 'Timing' ? Number(TimeLimit) : seconds + 1,
          totalErrors,
          percentageCorrectness,
          wordCount,
          formattedText.join('<br>'),
          text1.join(' ').trim(),
          para
        );

        await Axios({
          url: '/api/savetypingResult',
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          data: {
            id: userId,
            name: userName,
            email: userEmail,
            courseID: `${
              location?.state?.courseID && location.state.courseID !== 'undefined'
                ? location.state.courseID
                : sessionStorage.getItem('activityInstance')
            }`,
            testID: InstanceId[InstanceId.length - 1],
            result: {
              wpm: wam,
              error: totalErrors,
              timetaken: exerciseType === 'Timing' ? Number(TimeLimit) : seconds + 1,
              wordcount: wordCount,
              exName:
                instanceData.Activities.Activity.Label +
                ' ' +
                instanceData.Activities.Activity.Title
            },
            examtime: new Date().toISOString()
          }
        });

        // console.log(res);
        setError(totalErrors);
        setWordCount(wordCount);
      }
    }
    return matches;
  };
  //SJK: CKey-79: Modify function as per CKey-99
 /* function isPartialOfTarget(input, target) {
  if (input === '') return true;

  const inputStr = String(input);
  const targetStr = String(target);

  return targetStr.startsWith(inputStr);
  } 

  function isPartialOfTarget(userLines, modelLines, index, currentInput, currentTarget) {
  const inputStr = String(currentInput ?? '').trim();
  const targetStr = String(currentTarget ?? '').trim();
  // Empty input is allowed
  // SJK: CKey-99: Revise condition to throw empty string to false
  if (inputStr === '') return false;
   // Find actual last typed element
  const lastTypedIndex = userLines.map(v => String(v).trim()).filter(Boolean).length - 1;
  const isLastUserInput = index === lastTypedIndex;
  // Only last user input can be partial
  if (isLastUserInput) {
   // console.log(inputStr, targetStr);
    return targetStr.startsWith(inputStr);
  }
  // All previous inputs must match fully
  return inputStr === targetStr;
} */

function isPartialOfTarget(userTyped, reference, lineIndex, i, currentInput, currentTarget) {
    const input = String(currentInput ?? '').trim();
    const target = String(currentTarget ?? '').trim();

    // Empty input cannot be partial
    if (input === '' || target === '') {
        return false;
    }

    // --------------------------------------------------
    // Find the last user-typed cell in the entire matrix
    // --------------------------------------------------
    let lastRow = -1;
    let lastCol = -1;

    for (let r = userTyped.length - 1; r >= 0; r--) {
        const row = String(userTyped[r] ?? '');

        const cells = row.split(/\s+/);

        for (let c = cells.length - 1; c >= 0; c--) {
            const rawCell = cells[c] ?? '';

            /*
             * A completely empty cell is represented by only ⧗.
             *
             * Example:
             *     ⧗⧗⧗⧗       -> empty
             *
             * A cell containing actual user input has characters
             * other than ⧗.
             *
             * Example:
             *     3⧗⧗⧗        -> contains user input "3"
             */
            const typedValue = rawCell
                .replaceAll('⧗', '')
                .trim();

            if (typedValue !== '') {
                lastRow = r;
                lastCol = c;
                break;
            }
        }

        if (lastRow !== -1) {
            break;
        }
    }

    // --------------------------------------------------
    // Current cell must be the last user-typed cell
    // --------------------------------------------------
    if (lineIndex !== lastRow || i !== lastCol) {
        return false;
    }

    // --------------------------------------------------
    // Last typed cell is partial only when:
    //   input != target
    //   AND target starts with input
    // --------------------------------------------------
    return (
        input !== target &&
        target.startsWith(input)
    );
}

  // SJK: CKey-98: Check for split word match and incorrect morphology
  // SJK: CKey-99: Make condition on activity type to manipulate index for Timing Keypad activities
   function isSplitMatch(
    userWord,
    userIndex,
    userWords,
    modelText,
    modelIndex,
    activity_type
  ) {
    if (userIndex === 0) {
      sessionStorage.removeItem("hasSplit");
      sessionStorage.removeItem("splitIndex");
      sessionStorage.removeItem("extraSplit");
      sessionStorage.removeItem("extrasplitIndex");
      sessionStorage.removeItem("extrasplitCount");
      sessionStorage.removeItem("splitCount");
      sessionStorage.removeItem("hasDuplicate");
      sessionStorage.removeItem("duplicateCount");
      sessionStorage.removeItem("duplicatesplitIndex");
      sessionStorage.removeItem("hasincorrect");
      sessionStorage.removeItem("incorrectsplitIndex");
      sessionStorage.removeItem("incorrectCount");
    }

    if (!modelText || !userWords || userIndex == null) {
      return { isValid: false, isError: true, reason: 'Invalid input' };
    }

    const hasSplit = JSON.parse(sessionStorage.getItem("hasSplit")) ?? false;
    const splitIndex = JSON.parse(sessionStorage.getItem("splitIndex")) ?? 'null';
    const extraSplit = JSON.parse(sessionStorage.getItem("extraSplit")) ?? false;
    const extrasplitIndex = JSON.parse(sessionStorage.getItem("extrasplitIndex")) ?? 'null';
    let extrasplitCount = JSON.parse(sessionStorage.getItem("extrasplitCount")) ?? 0;
    let splitCount = JSON.parse(sessionStorage.getItem("splitCount")) ?? 0;
    const hasDuplicate = JSON.parse(sessionStorage.getItem("hasDuplicate")) ?? false;
    const duplicatesplitIndex = JSON.parse(sessionStorage.getItem("duplicatesplitIndex")) ?? 'null';
    let duplicateCount = JSON.parse(sessionStorage.getItem("duplicateCount")) ?? 0;
    const hasincorrect = JSON.parse(sessionStorage.getItem("hasincorrect")) ?? false;
    const incorrectsplitIndex = JSON.parse(sessionStorage.getItem("incorrectsplitIndex")) ?? 'null';
    let incorrectCount = JSON.parse(sessionStorage.getItem("incorrectCount")) ?? 0;
    /* ---------- helpers ---------- */

    const normalizeWord = (w) =>
      (w ?? '')
        // .toLowerCase()
        .replace(/[^a-z0-9.,;]/g, '');

    /* ---------- model words ---------- */

    const modelWords = Array.isArray(modelText)
      ? modelText
      : modelText.trim().split(/\s+/);

    /* ---------- neighbors ---------- */

    const prevWord = userWords[userIndex - 1] ?? '';
    const nextWord = userWords[userIndex + 1] ?? '';
    const prevModelWord = modelWords[modelIndex - 1] ?? '';
    const nextModelWord = modelWords[modelIndex + 1] ?? '';

    const u = normalizeWord(userWord);
    let p = normalizeWord(prevWord);
    let n = normalizeWord(nextWord);

    const uwl = userWords.length;
    const mwl = modelWords.length;
    
    /* -------- Index alignment ---------- */

    let modelIndex1 = userIndex;
    // SJK: CKey-99: Make condition on activity type to manipulate index 
    if(['ReinforcementDrillKeypadTab', 'ReinforcementDrillKeypadEnter', 'TimingKeypadTab', 'TimingKeypadEnter','DrillLinesKeypadTab', 'DrillLinesKeypadEnter'].includes(activity_type)){
      modelIndex1 = modelIndex;
    }
    else if ((!hasSplit && splitIndex === null)) {
      modelIndex1 = userIndex;
    }
    // Second half of split → stay on same model word
    else if ((userIndex === splitIndex + 1) && hasSplit) {
     modelIndex1 = modelIndex - (extrasplitCount + splitCount + duplicateCount + incorrectCount);
    }
    // After split → shift model index forward
    else if ((userIndex > splitIndex + 1) && hasSplit && !extraSplit) {
     modelIndex1 = modelIndex - (extrasplitCount + splitCount + duplicateCount + incorrectCount);
    }
    else if (((userIndex >= extrasplitIndex + 1) && extraSplit)){
      if(hasSplit || extraSplit || hasDuplicate || hasincorrect){
        modelIndex1 = modelIndex - (extrasplitCount + splitCount + duplicateCount + incorrectCount);
      } else {
      modelIndex1 = userIndex - (extrasplitCount) ;}
    }
    else if (((userIndex >= duplicatesplitIndex + 1) && hasDuplicate)){
      if(hasSplit || extraSplit || hasDuplicate || hasincorrect){
        modelIndex1 = modelIndex - (extrasplitCount + splitCount + duplicateCount + incorrectCount);
      }else {
      modelIndex1 = userIndex - (duplicateCount) ;}
    }
    else if (((userIndex >= incorrectsplitIndex + 1) && hasincorrect)){
      if(hasSplit || extraSplit || hasDuplicate || hasincorrect){
        modelIndex1 = modelIndex - (extrasplitCount + splitCount + duplicateCount + incorrectCount);
      } else {
      modelIndex1 = userIndex - (incorrectCount) ;}
    }
    // Safety fallback
    else {
      modelIndex1 = modelIndex;
    }


    const comparedWord = modelWords[modelIndex1] ?? '';
    const c = normalizeWord(comparedWord);
    const lastWord = normalizeWord(modelWords[mwl - 1] ?? '');

    // Clear session to the end of user's last word
    const isLastUserWord = userIndex === userWords.length - 1;

    /* -------- Direct Match ---------- */
    if (u === c) {
      return { isValid: true, type: 'direct-match' };
    }

    /* ======================================================
      SPLIT RECOVERY (FIRST HALF)
      sales + man → salesman
      ====================================================== */

   
   const nextValidWord = getNextValidWord(userWords, userIndex);
  // if (u && n && u + n === c) {
   if (u && nextValidWord && u + nextValidWord === c) {
      return {
        isValid: true,
        type: 'split-recover'
      };
    }

    /* ======================================================
      SPLIT ERROR (SECOND HALF)
      ====================================================== */
     
   const prevValidWord = getPrevValidWord(userWords, userIndex); 
   if ((prevValidWord && u && (prevValidWord + u === modelWords[modelIndex1-1]))) {
      sessionStorage.setItem("hasSplit", JSON.stringify(true));
      sessionStorage.setItem("splitIndex", JSON.stringify(modelIndex1-1));
      ++splitCount;
      sessionStorage.setItem("splitCount", JSON.stringify(splitCount));
      return {
        isValid: false,
        type: 'split-error',
        reason: 'Extra space inside word',
        missindex: `${userIndex}`
      };
    }
    /* -------- Extra Space ---------- */
    if ((p && u === ""  && c === modelWords[modelIndex1])  || ((p === "" && n === "" && c === "")) || (p === "" && u === ""  && c === modelWords[modelIndex1]) || (p === "" && u === lastWord && c === "")) {
      sessionStorage.setItem("extraSplit", JSON.stringify(true));
      sessionStorage.setItem("extrasplitIndex", JSON.stringify(userIndex));
      ++extrasplitCount;
      sessionStorage.setItem("extrasplitCount", JSON.stringify(extrasplitCount));
      return {
        isValid: false,
        type: 'extra-space',
        reason: 'Extra space inside word',
        missindex: `${modelIndex1}`
      };
    }
    
    /* -------- Missing Words ---------- */

    const prevUserWord = normalizeWord(userWords[userIndex - 1] ?? '');
    const currentUserWord = u;

    if(currentUserWord){
      const expectedModelWord = normalizeWord(modelWords[modelIndex1] ?? '');
      const normalizedUser = normalizeWord(currentUserWord);
      // get previous valid word ignoring extra spaces
      const prevValidWord = getPrevValidWord(userWords, userIndex);
     //Duplicate word check (consecutive)
      if ((
        prevValidWord &&
        normalizedUser === normalizeWord(prevValidWord)) || (
        prevValidWord &&
        userWord === prevValidWord.toLowerCase()) ||
        (prevValidWord &&
        userWord.toLowerCase() === prevValidWord.toLowerCase()) ||
        (prevValidWord &&
        prevValidWord.toLowerCase().startsWith(userWord.toLowerCase()))
      ) {
        sessionStorage.setItem("hasDuplicate", JSON.stringify(true));
        sessionStorage.setItem("duplicatesplitIndex", JSON.stringify(userIndex));
        ++duplicateCount;
        sessionStorage.setItem("duplicateCount", JSON.stringify(duplicateCount));
        return {
          isValid: false,
          type: 'duplicate-word'
        };
      }  
    // Try to realign
    const realignedIndex = findNextModelIndex(
      currentUserWord,
      modelWords,
      modelIndex1
    );
     // SJK: CKey-99: Make condition on activity type to manipulate index 
    if (prevValidWord && realignedIndex > modelIndex1 && !['ReinforcementDrillKeypadTab', 'ReinforcementDrillKeypadEnter','TimingKeypadTab', 'TimingKeypadEnter','DrillLinesKeypadTab', 'DrillLinesKeypadEnter'].includes(activity_type)) {
      // Skipped model words exist
      return {
        isValid: false,
        type: 'missing-word',
        missindex: modelIndex1,
        missingCount: realignedIndex - modelIndex1
      };
    } 
    // If we cannot realign AND user word doesn't match expected → error word
    if (realignedIndex === -1 && normalizedUser !== expectedModelWord) {
        if(modelIndex1 === 0){
          return {
              isValid: false,
              type: 'missing-word',
              missindex: modelIndex1,
              missingCount: 1
            };
        }
        else{
            sessionStorage.setItem("hasincorrect", JSON.stringify(true));
            sessionStorage.setItem("incorrectsplitIndex", JSON.stringify(modelIndex1));
            ++incorrectCount;
            sessionStorage.setItem("incorrectCount", JSON.stringify(incorrectCount));
          return {
            isValid: false,
            type: 'incorrect-word'
          }; }
        }
    }
    /* -------- Invalid Word ---------- */
    if(u !== c){
      return { isValid: false, type: 'invalid-word' };
    }
    /* --------- Last Word -----------*/
    if(u === userWords[uwl-1]){
       return { isValid: true, type: 'last-word' };
    }
    return {
      isValid: false,
      isError: true,
      reason: `"${userWord}" is incorrect and breaks sentence alignment`
    };
  }
  function findNextModelIndex(userWord, modelWords, startIndex, lookahead = 4) {
      const normalizeWord = (w) =>
        (w ?? '')
          // .toLowerCase()
          .replace(/[^a-z0-9]/g, '');
      const uw = normalizeWord(userWord);
      for (let i = startIndex; i < Math.min(modelWords.length, startIndex + lookahead); i++) {
        if (normalizeWord(modelWords[i]) === uw) {
          return i;
        }
      }
      return -1;
    }
    const getPrevValidWord = (userWords, index) => {
    for (let i = index - 1; i >= 0; i--) {
      if (userWords[i] && userWords[i].trim() !== '') {
        return userWords[i];
      }
    }
    return null;
};
function getNextValidWord(words, startIndex) {
  for (let i = startIndex + 1; i < words.length; i++) {
    if (words[i]?.trim()) return words[i];
  }
  return null;
}

  // eslint-disable-next-line no-unused-vars
  const wordMatchArray = async (text1, para) => {
    //console.log("JG Debug wordMatchArray");
    //console.log(exerciseType);
    let matches = 0; // Count of correctly matched words
    let totalErrors = 0; // Total errors based on new conditions
    const isTabDrill = exerciseTitle.includes('Tab Drill');
    let formattedText = []; // Store formatted results for each line
    let resultHTML = [];
    let displayErrors = instanceData?.Activities.Activity.attributes.DisplayErrors;
    displayErrors = !['0', 'False', 'false'].includes(displayErrors);
    const [oldText, newText] = [[], []];
    // console.log(`\n------------------------------------------------------------\n`);
    let lastLineTyped = 0;
    let lastWordTyped = 0;
    if (Array.isArray(text1)) {
      text1.forEach((item, index) => {
        if (typeof item !== 'string') return;
        const filteredLine = item.replace(/⧗/g, '').trim();
        if (filteredLine.length > 0) {
          lastLineTyped = index;
          item
            .trim()
            .split(' ')
            .forEach((word, wordIndex) => {
              if (word.replace(/⧗/g, '').trim()) {
                lastWordTyped = wordIndex;
              }
            });
        }
      });
    }
    // SJK: CKey-99 : Define activity type
    let activity_type = instanceData?.Activities?.Activity?.attributes?.Type;
    if (innitialLineCount < para.length) {
      lastLineTyped = para.length - 1;
    }
    for (let lineIndex = 0; lineIndex < Math.max(text1.length, para.length); lineIndex++) {
      const line1 = text1[lineIndex]?.split(isTabDrill ? '\t' : ' ') || [];
      const line2 = para[lineIndex]?.split(isTabDrill ? /\s+/ : ' ') || [];
      if (line1.length < line2.length) {
        for (let len = line1.length; len < line2.len; len++) {
          line1.push('');
        }
        // console.log(line1, line2);
      }
      // console.log(line1, line2);
      let lineFormattedText = '';
      let lineMatches = 0;
      let lineErrors = 0;

      let i = 0,
        j = 0;
      let lineFormattedText2 = '';
      while (i < line1.length || j < line2.length) {
        //CKey-99 : change replace to replaceAll
        const word1 = line1[i]?.replaceAll(/⧗/g, '') || ''; // Word from text1
        const word2 = line2[j] || ''; // Word from para
        oldText.push(word2);
        newText.push(word1);
        let markError = lineIndex <= lastLineTyped;
        markError = markError && (lineIndex != lastLineTyped || i <= lastWordTyped);
        if (!instanceData?.Activities?.Activity?.attributes?.Type.startsWith('Timing')) {
          markError = true;
        }
        const partial_target = isPartialOfTarget(text1, para, lineIndex, i, word1.trim(), word2.trim());
        // SJK: CKey-98, 99: To evaluate as per activity type
          const result = isSplitMatch(
            word1,
            i,
            line1,
            line2,
            j,
            activity_type
          );
         // CKey-99: Revise condition to avoid extra cell
         if(result.type === 'missing-word' && Number.isInteger(result.missindex) && result.missindex > 0) {
           line1.splice(result.missindex, 0, "");
         } 
        //////////
        if (instanceData.Activities.Activity.attributes.DisplayErrors === '1') {
          // SJK : CKey-98 : Commenting  code for new evaluation
         /* if (word1 === word2) {
            lineMatches++;
            lineFormattedText += `<span>${word1}</span> `;
          // } else if (isCapitalizationError(word1, word2)) {
          //   lineErrors++;
          //   lineFormattedText += `<span style="color: purple;">${word1}</span> `;
          // } else if (isWrongWord(word1, word2)) {
          //   lineErrors++;
          //   lineFormattedText += `<span style="color: blue;">${word1}</span> `;
          // } else if (isDuplicateWord(line1, i)) {
          //   lineErrors++;
          //   lineFormattedText += `<span style="color: orange;">${word1}</span> `;
          // } else if (isNumberError(word1, word2)) {
          //   lineErrors++;
          //   lineFormattedText += `<span style="color: green;">${word1}</span> `;
          // } else if (isPunctuationError(word1, word2)) {
          //   lineErrors++;
          //   lineFormattedText += `<span style="color: darkred;">${word1}</span> `;
          } else if (word1 === '') {
            lineErrors++;
            lineFormattedText += `<span style="color: red;">&#x2191;</span> `;
          } else if (word2 === '') {
            lineErrors++;
            lineFormattedText += `<span style="text-decoration: line-through; color: red;">${word1}</span> `;
          } else {
            lineFormattedText += `<span style="text-decoration: line-through; color: red;">${word1}</span> `;
          }*/
           if (word1 === word2) {
                //CKey-99 : Make more strict condition
                if(result.type === "extra-space" && !result.isValid){
                    lineFormattedText += `<span style="color: red;">&#x2191;</span> `;
                } else{
                lineFormattedText += `<span>${word1}</span> `;
                }
              } else if ((result.type === 'missing-word') || (word1 === '')) {
                // Ckey-99 : Adding additional cases to accomodate Numeric Timing
                if(word1 !== "" && word2 !==""){
                  //  if(isPartialOfTarget(word1.trim(), word2.trim())){
                   if (partial_target) {
                       lineFormattedText += `<span>${word1}</span> `;
                    } else{
                   lineFormattedText += `<span style="text-decoration: line-through; color: red;">${word1}</span> `; }
                } else {
                lineFormattedText += `<span style="color: red;">&#x2191;</span> `; }
              } else if ((word2 === '' )) {
                if(!result.isValid){
                lineFormattedText += `<span style="text-decoration: line-through; color: red;">${word1}</span> `;
                }
                else{
                  lineFormattedText += `<span>${word1}</span> `;
                }
              } else {
                if(result.isValid){
                  lineFormattedText += `<span>${word1}</span> `;
                } else{
                  if(result.type === 'missing-word' || result.type === 'extra-space')
                  {
                    lineFormattedText += `<span style="color: red;">&#x2191;</span> `;
                  } else if(result.isValid){
                    lineFormattedText += `<span>${word1}</span> `;
                  }
                  else {
                    // CKey-99 : Adding additional cases to accomodate Numeric Timing
                    // if(isPartialOfTarget(word1.trim(), word2.trim())){
                    if (partial_target) {
                       lineFormattedText += `<span>${word1}</span> `;
                    } else{
                   lineFormattedText += `<span style="text-decoration: line-through; color: red;">${word1}</span> `; }
                  }
                }
              }  
        } else {
          // SJK : CKey-98 : commented code for new evaluation
          // lineFormattedText += `<span>${word1}</span> `;
          if (word1 === word2) {
                if(result.type === "extra-space" || !result.isValid){
                    lineFormattedText += `<span style="color: red;">&#x2191;</span> `;
                } else{
                lineFormattedText += `<span>${word1}</span> `;
                }
              } else if ((result.type === 'missing-word') || (word1 === '')) {
                // lineFormattedText += `<span style="color: red;">&#x2191;</span> `;
                // SJK: Ckey-99
                if(word1 !== "" && word2 !==""){
                  //  if(isPartialOfTarget(word1.trim(), word2.trim())){
                       if (partial_target) {
                       lineFormattedText += `<span>${word1}</span> `;
                    } else{
                   lineFormattedText += `<span style="text-decoration: line-through; color: red;">${word1}</span> `; }
                } 
                // SJK: CKey-99 : Control to display extra-space
                else if (['ReinforcementDrillKeypadTab', 'ReinforcementDrillKeypadEnter','TimingKeypadTab', 'TimingKeypadEnter','DrillLinesKeypadTab', 'DrillLinesKeypadEnter'].includes(activity_type)){
                  lineFormattedText += "";
                }
                else {
                lineFormattedText += `<span style="color: red;">&#x2191;</span> `; }
              } else if ((word2 === '' )) {
                if(!result.isValid){
                lineFormattedText += `<span style="text-decoration: line-through; color: red;">${word1}</span> `;
                }
                else{
                  lineFormattedText += `<span>${word1}</span> `;
                }
              } else {
                if(result.isValid){
                  lineFormattedText += `<span>${word1}</span> `;
                } else{
                  if(result.type === 'missing-word' || result.type === 'extra-space')
                  {
                    lineFormattedText += `<span style="color: red;">&#x2191;</span> `;              
                  } else if(result.isValid){
                    lineFormattedText += `<span>${word1}</span> `;
                  }
                  else {
                    // CKey-99
                    // if(isPartialOfTarget(word1.trim(), word2.trim())){
                     if (partial_target) {
                       lineFormattedText += `<span>${word1}</span> `;
                    } else{
                   lineFormattedText += `<span style="text-decoration: line-through; color: red;">${word1}</span> `; }
                }
                }
              }  
        }
        // SJK : CKey-98 : Commenting existing code for new evaluation
        /*if (word1 === word2) {
          lineFormattedText2 += `<span>${word1}</span> `;
        // } else if (isCapitalizationError(word1, word2)) {
        //   lineFormattedText2 += `<span style="color: purple;">${word1}</span> `;
        // } else if (isWrongWord(word1, word2)) {
        //   lineFormattedText2 += `<span style="color: blue;">${word1}</span> `;
        // } else if (isDuplicateWord(line1, i)) {
        //   lineFormattedText2 += `<span style="color: orange;">${word1}</span> `;
        // } else if (isNumberError(word1, word2)) {
        //   lineFormattedText2 += `<span style="color: green;">${word1}</span> `;
        // } else if (isPunctuationError(word1, word2)) {
        //   lineFormattedText2 += `<span style="color: darkred;">${word1}</span> `;
        } else if (word1 === '' || (result.type === 'missing-word')) {
          lineFormattedText2 += `<span style="color: red;">&#x2191;</span> `;
        } else if (word2 === '' && !result.isValid) {
          lineFormattedText2 += `<span style="text-decoration: line-through; color: red;">${word1}</span> `;
        } else {
          // SJK : CKey-98 : commented code & added conditions above
          // lineFormattedText2 += `<span style="text-decoration: line-through; color: red;">${word1}</span> `;
            if(result.isValid){
              lineFormattedText2 += `<span>${word1}</span> `;
            } else{
              if(result.type === 'missing-word')
              {
                lineFormattedText2 += `<span style="color: red;">&#x2191;</span> `;
              } else if(result.isValid){
                lineFormattedText2 += `<span>${word1}</span> `;
              }
              else {
              lineFormattedText2 += `<span style="text-decoration: line-through; color: red;">${word1}</span> `; }
            }
        }*/
              // CKey-99: Apply all conditions for display on Moodle end
            if (word1 === word2) {
                if(result.type === "extra-space" || !result.isValid){
                    lineErrors++;
                    lineFormattedText2 += `<span style="color: red;">&#x2191;</span> `;
                } else{
                lineFormattedText2 += `<span>${word1}</span> `;
                }
              } else if ((result.type === 'missing-word') || (word1 === '')) {
                // lineFormattedText += `<span style="color: red;">&#x2191;</span> `;
                // SJK: Ckey-99
                if(word1 !== "" && word2 !==""){
                  //  if(isPartialOfTarget(word1.trim(), word2.trim())){
                       if (partial_target) {
                       lineFormattedText2 += `<span>${word1}</span> `;
                    } else{
                      lineErrors++;
                   lineFormattedText2 += `<span style="text-decoration: line-through; color: red;">${word1}</span> `; }
                } 
                // SJK: CKey-99 
                else if (['ReinforcementDrillKeypadTab', 'ReinforcementDrillKeypadEnter','TimingKeypadTab', 'TimingKeypadEnter', 'DrillLinesKeypadTab', 'DrillLinesKeypadEnter'].includes(activity_type)){
                  lineFormattedText2 += "";
                }else {
                  lineErrors++;
                lineFormattedText2 += `<span style="color: red;">&#x2191;</span> `; }
              } else if ((word2 === '' )) {
                if(!result.isValid){
                  lineErrors++;
                lineFormattedText2 += `<span style="text-decoration: line-through; color: red;">${word1}</span> `;
                }
                else{
                  lineFormattedText2 += `<span>${word1}</span> `;
                }
              } else {
                if(result.isValid){
                  lineFormattedText2 += `<span>${word1}</span> `;
                } else{
                  if(result.type === 'missing-word' || result.type === 'extra-space')
                  {
                    lineErrors++;
                    lineFormattedText2 += `<span style="color: red;">&#x2191;</span> `;              
                  } else if(result.isValid){
                    lineFormattedText2 += `<span>${word1}</span> `;
                  }
                  else {
                    // CKey-99
                    // if(isPartialOfTarget(word1.trim(), word2.trim())){
                     if (partial_target) {
                       lineFormattedText2 += `<span>${word1}</span> `;
                    } else{
                      lineErrors++;
                   lineFormattedText2 += `<span style="text-decoration: line-through; color: red;">${word1}</span> `; }
                }
                }
              } 
        i++;
        j++;
        // SJK: CKey-79: Not to count partial word as error for timing activities
        /*resultHTML += `<span ${
          markError && word1 !== word2 && displayErrors
            ? 'style="background-color: lightcoral;"'
            : ''
        }>${word2}</span> `;*/
         if(markError && (word1 !== word2) && displayErrors && (!instanceData?.Activities?.Activity?.attributes?.Type.startsWith('Timing'))){
          // SJK : CKey-98 : Commented code
          /* resultHTML += `<span ${
          markError && word1 !== word2 && displayErrors
            ? 'style="background-color: lightcoral;"'
            : ''
        }>${word2}</span> `; */
         if(result.isValid){
            resultHTML += `<span>${word1}</span> `;
          } else if(result.type === 'missing-word' || result.type === 'extra-space'){
            resultHTML += `<span style="color: red;">&#x2191;</span>`;
          }else{
          resultHTML += `<span ${
          markError && word1 !== word2 && displayErrors
            ? 'style="background-color: lightcoral;"'
            : ''
          }>${word1}</span> `;
        }
      } else {
               // if(isPartialOfTarget(word1, word2)){
                if (partial_target) {
                resultHTML += `<span>${word2}</span> `;
              } else{
                resultHTML += `<span ${
                  markError && word1 !== word2 && displayErrors
                    ? 'style="background-color: lightcoral;"'
                    : ''
                }>${word2}</span> `;
              }   
      }
    }

      matches += lineMatches;
      totalErrors += lineErrors;
      formattedText.push(lineFormattedText.trim()); // Store formatted line result
      ExerciseResultsArray.push(lineFormattedText2.trim());
      if (lineIndex < Math.max(text1.length, para.length) - 1) {
        resultHTML += '<br>';
      }
    }

    setResultHTML(resultHTML);
    setResultHTML2(formattedText.join('<br>')); // Join formatted text results
    ExerciseResults = ExerciseResultsArray.join('<br>');
    // Calculate WPM based on total words typed (not only matches) and duration in minutes

    let wordCount = 0;
    let old = text1;
    let inp = para;
    if (isTabDrill) {
      wordCount =
        text1?.reduce((acc, line) => acc + line.replace(/_/g, '').split('\t').length, 0) ?? 0;
    } else {
      let tempText = text1?.join(' ').replace(/_/g, '').replace(/ {2,}/g, ' ') ?? '';
      // console.log(tempText);
      wordCount = tempText?.trim().split(' ').length ?? 0;
      // console.log(tempText);
    }
    const wam = Math.round(wordCount / ((seconds + 1) / 60));
    const percentageCorrectness = (matches / wordCount) * 100;

    if (typeof old === 'string') old = [old];
    if (typeof inp === 'string') inp = [inp];
    // totalErrors = 0; SJK: CKey-98
    let actualErrors = 0;
     // SJK: CKey-98 
    let evalerrors = totalErrors;
    totalErrors = 0;
    inp.forEach((line, index) => {
      const line1 = old[index]?.split(isTabDrill ? '\t' : ' ') || [];
      const line2 = inp[index]?.split(isTabDrill ? /\s+/ : ' ') || [];
      //SJK: CKey-99: Throwing double errors with the below. Hence commenting
      /*if (line1.length !== line2.length) {
        actualErrors += line2.length - line1.length;
      }*/
       // SJK: CKey-99: Define last user input
      const isLastInputLine = index === old.length - 1;
      if (line1.length === 1 && line1[0].trim() === '') {
          // Count every non-empty word in the model line as an error
          actualErrors += line2.filter(word => word.trim() !== '').length;
          totalErrors = actualErrors;
          return; // Skip the rest of the processing for this line
      } 
      for (let i = 0; i < line1.length; i++) {
        // SJK: CKey-79: Restructure error calculation function
        /*if (line1[i] != line2[i]) {
          actualErrors++;
        }
        if (line1[i]?.replace('⧗', '').trim() && line2[i]?.replace('⧗', '').trim()) {
          totalErrors = actualErrors;
        }*/
        // CKey-99: Revise function replace to replaceAll
         line1[i] = line1[i]?.replaceAll('⧗', '').trim();
         line2[i] = line2[i]?.replaceAll('⧗', '').trim();
         // SJK: CKey-99 : Define last input index
         const lastTypedIndex = line1.reduce((last, word, idx) => {
          return word.trim() !== '' ? idx : last;
         }, -1);
        if (line1[i] != line2[i] && (!instanceData?.Activities?.Activity?.attributes?.Type.startsWith('Timing'))) {
          actualErrors++;
        } else{
           const ispartial = isPartialOfTarget(old, inp, index, i, line1[i].trim(), line2[i].trim());
          if(ispartial || (isLastInputLine && i > lastTypedIndex)){
            // Do not count as error
          } else if(line1[i] != line2[i]) {
            actualErrors++;
          }
        }
        totalErrors = actualErrors;
      }
    });
    // SJK: CKey-98 : Revise condition to display errors
     if (instanceData?.Activities?.Activity?.attributes?.Type.startsWith('Timing')) {
      totalErrors = actualErrors;
    } else {
      totalErrors = evalerrors;
    }

    // Logging for debugging purposes
    // console.log(`Total Word Count (Typed): ${wordCount}`);
    // console.log(`Seconds: ${seconds}`);
    // console.log(`Total Errors: ${totalErrors}`);
    // console.log(`Correctness: ${Math.round(percentageCorrectness)}%`);
    // console.log(`WPM: ${wam}`);

    setErrorValueEach(totalErrors);
    setWpmValueEach(wam);
    setWpmValue(wam);
    if (exerciseType === 'TimingKeypadTab' || exerciseType === 'TimingKeypadEnter') {
      setError(totalErrors);
      setWordCount(wordCount);
      return;
    } else {
      //JG Debug
      //console.log(result);
      //console.log(exerciseType);
      if (result || exerciseType !== 'Timing') {
        const userId = userContext?.userData?.id || localStorage.getItem('userid');
        const userName = userContext?.userData?.fullname || localStorage.getItem('username');
        const userEmail = userContext?.userData?.email || localStorage.getItem('userEmail');
        formattedText = formattedText.filter(item => item.trim() !== '');
        let formattedTextFinal = formattedText
          .join('<br>')
          .replace(/^(<br\s*\/?>\s*)+/i, '')
          .replace(/(\s*<br\s*\/?>)+$/i, '')
          .trim();
        sendDataToMood(
          userId,
          InstanceId[InstanceId?.length - 1],
          wam,
          seconds + 1,
          totalErrors,
          percentageCorrectness,
          wordCount,
          formattedTextFinal,
          text1.join(isTabDrill ? '\t' : ' ').trim(),
          oldText,
          newText
        );

        await Axios({
          url: '/api/savetypingResult',
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          data: {
            id: userId,
            name: userName,
            email: userEmail,
            courseID: `${
              location?.state?.courseID && location.state.courseID !== 'undefined'
                ? location.state.courseID
                : sessionStorage.getItem('activityInstance')
            }`,
            testID: InstanceId[InstanceId.length - 1],
            result: {
              wpm: wam,
              error: totalErrors,
              timetaken: seconds + 1,
              wordcount: wordCount,
              exName:
                instanceData.Activities.Activity.Label +
                ' ' +
                instanceData.Activities.Activity.Title
            },
            examtime: new Date().toISOString()
          }
        });

        // console.log(res);
        setError(totalErrors);
        setWordCount(wordCount);
      }
    }
    return matches; // Return the number of correct matches
  };

  useEffect(() => {
    if (!result) {
      if (showRepsDataValue === 0 && text?.length > 0) {
        const timer = setTimeout(() => setSeconds(prevSeconds => prevSeconds + 1), 1000);

        // Cleanup to avoid memory leaks
        return () => clearTimeout(timer);
      } else if (showRepsDataValue !== 0) {
        const timer = setTimeout(() => setSeconds(prevSeconds => prevSeconds + 1), 1000);

        // Cleanup to avoid memory leaks
        return () => clearTimeout(timer);
      }
    }
  }, [secondflag, seconds, result, showRepsDataValue]);
  // console.log(result);

  useEffect(async () => {
    if ((exerciseType === 'TimingKeypadEnter' || exerciseType === 'TimingKeypadTab') && result) {
      const moodleFormattedInput = allText
        .replace(/\n/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/^(<br\s*\/?>\s*)+/i, '')
        .replace(/(\s*<br\s*\/?>)+$/i, '')
        .trim();
      const userId = userContext?.userData?.id || localStorage.getItem('userid');
      // const userName = userContext?.userData?.fullname || localStorage.getItem('username');
      // const userEmail = userContext?.userData?.email || localStorage.getItem('userEmail');
      const courseIDSelected =
        localStorage.getItem('courseIdselected') &&
        localStorage.getItem('courseIdselected') !== 'undefined'
          ? localStorage.getItem('courseIdselected')
          : sessionStorage.getItem('activityInstance');
      const keyStats = getKeysStatistics(repsData, allText, keyData, instanceData);
      const keysXML = generateKeysXML(keyStats);
      const userName = userContext?.userData?.fullname || localStorage.getItem('username');
      const userEmail = userContext?.userData?.email || localStorage.getItem('userEmail');
      const finalResultXML = `<ResultText><![CDATA[\n${allResultTableRowsRef.current.join(
        '\n'
      )}\n]]></ResultText>`;
      const xmlData = `
      <ResultXml>
          <CourseId>${courseIDSelected}</CourseId>
        <UserId>${userId}</UserId>
          <ActivityResult>
            <ActivityId>${InstanceId[InstanceId?.length - 1]}</ActivityId>
            <WAM>${wpmValue}</WAM>
              <Time></Time>
            <TimeTaken>${Number(TimeLimit)}</TimeTaken>
            <TotalErrors>${errorValueEach}</TotalErrors>
                  <UserInput><![CDATA[${moodleFormattedInput.replace(/⧗/g, ' ')}]]></UserInput>
            ${finalResultXML.replace(/⧗/g, ' ')}
              <Keys>
                ${keysXML}
              </Keys>
          </ActivityResult>
      </ResultXml>
    `.replace(/&^#x2191/g, '&#x2191');

      try {
        // Make the POST request
        await axios.post(
          `${process.env.REACT_APP_MOODLE_DEVELOPMENT_URL}/mod/kb/appservice_kbws.php?action=postresult`,
          xmlData,
          {
            headers: {
              'Content-Type': 'application/xml' // Set the Content-Type header to application/xml
            }
          }
        );

        await Axios({
          url: '/api/savetypingResult',
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          data: {
            id: userId,
            name: userName,
            email: userEmail,
            courseID: `${
              location?.state?.courseID && location.state.courseID !== 'undefined'
                ? location.state.courseID
                : sessionStorage.getItem('activityInstance')
            }`,
            testID: InstanceId[InstanceId.length - 1],
            result: {
              wpm: wpmValue,
              error: errorValueEach,
              timetaken: exerciseType === 'Timing' ? Number(TimeLimit) : seconds + 1,
              wordcount: wordCount,
              exName:
                instanceData.Activities.Activity.Label +
                ' ' +
                instanceData.Activities.Activity.Title
            },
            examtime: new Date().toISOString()
          }
        });
        // Handle the response
        // console.log('Response:', res, response);
      } catch (error) {
        // Handle any errors
        console.error('Error:', error);
        
        const res = await axios({
                  url: '/api/logs',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  data: {
                    user: userId,
                    time: Date.now(),
                    activity: xmlData,
                    message: error,
                  }
                });
      }
    }
  }, [seconds, result]);
  useEffect(() => {
    // console.log(secondflag);
    if (showRepsDataValue === 0 && text.length > 1) {
      setSecondflag(true);
    }
  }, [text]);
  useEffect(() => {
    if ((demo === false || demo === true) && scrollDiv.current)
      setTimeout(() => scrollDiv.current.scrollIntoView({ behavior: 'smooth' }), 500);
  }, [demo]);

  useEffect(() => {
    if (result === true && progress === 100)
      setTimeout(() => scrollResult?.current?.scrollIntoView({ behavior: 'smooth' }), 500);
  }, [result, progress]);

  // useEffect(() => {
  //   // console.log(`outside>> ${text}`);

  //   if (repsData.length > 0 && repsData[showRepsDataValue].length < text.length) {
  //     // console.log(`inside>> ${text}`);

  //     if (repsData.length - 1 !== showRepsDataValue) {
  //       setShowRepsDataValue(prev => prev + 1);
  //       setAllText(prev => prev + ' ' + text);

  //       comparison.push(text);
  //       setText('');
  //     } else {
  //       setTimeout(() => {
  //         alert('Please Submit to see the results');
  //       }, 500);
  //     }
  //   }
  // }, [text]);
  // Enter functionality
  // console.log(instanceData);
  // console.log(text);
  // useEffect(() => {
  //   // const handleUserKeyPress = e => {
  //   // if (e.keyCode === 13) {
  //   //   e.preventDefault();

  //   // if (repsData.length > 0 && repsData[showRepsDataValue].length <= text.length) {
  //   // console.log(text);

  //   // if (text.length === textLength) {
  //   // console.log(`inside>> ${text}`);
  //   // console.log(`lenth>> ${text.length} textLength>> ${textLength}`);
  //   const exetype = fieldType.split('/').pop();
  //   if (exetype.trim() != 'Timing') {
  //     if (showRepsDataValue + 1 === repsData.length) {
  //       // console.log('auto');
  //       TypingAutoSubmit();
  //     }
  //   }
  //   // }
  //   // }
  //   // };

  //   // window.addEventListener('keydown', handleUserKeyPress);
  // }, [text]);
  // window.addEventListener(
  //   'keydown',
  //   function (e) {
  //     if (['Enter'].indexOf(e.code) > -1) {
  //       setText('');
  //     }

  //     // if (['Enter'].indexOf(e.code) > -1) {
  //     //   if (instanceData.Activities.Activity.Title.includes('Keypad')) {
  //     //     e.preventDefault();
  //     //   } else {
  //     //     // console.log(text + ' ' + neva);
  //     //   }
  //     // }
  //   },
  //   false
  // );
  // const TypingAutoSubmit = () => {
  //   setAutomaticSubmit(() => true);
  // };
  const handleEnterEvent = () => {
    if (
      instanceData.Activities.Activity.attributes.Type.startsWith('Timing') ||
      repsData.length - 1 !== showRepsDataValue
    ) {
      setShowRepsDataValue(prev => prev + 1);
      setAllText(prev => prev + ' ' + text);
      comparison.push(text);
      setText('');
    } else {
      setTimeout(() => {
        alert('Please Submit to see the results');
      }, 500);
    }
  };
  const prgView = () => {
    setInterval(() => {
      setProgress(prevProgress => (prevProgress >= 100 ? 100 : prevProgress + 10));
    }, 800);
    return (
      <>
        {progress == 100 ? (
          <Button className={classes.buttonClick} variant="outlined">
            <CheckCircleOutlineIcon
              sx={{
                color: 'lightgreen'
              }}
              fontSize="large"
            />
          </Button>
        ) : (
          <Button className={classes.button} variant="outlined">
            <CircularProgress size={32} />
          </Button>
        )}
      </>
    );
  };
  /*  Prevent copy and paste */

  const handleChange = e => {
    e.preventDefault();
  };
  const sendDataToMood = async (
    userId,
    instanceId,
    wam,
    timeTaken,
    error,
    percentageCorrectness,
    wordcount,
    formatted,
    text1String,
    para,
    newText
  ) => {
    // Construct the XML body
    //const repsCount = repsData ? (repsData.length === 0 ? '1' : repsData.length) : '1';
    //const avgTime = Number(timeTaken) / Number(repsCount);
    ExerciseResults = [
      'DrillLinesKeypadTab',
      'DrillLinesKeypadEnter',
      'ReinforcementDrillKeypadTab',
      'ReinforcementDrillKeypadEnter'
    ].includes(instanceData.Activities.Activity.attributes.Type)
      ? ExerciseResults
        .replace(/> /g, '>')
        .replace(/<\/span><br><span/g, '</td></tr><tr><td')
        .replace(/<\/span><span/g, '</td><td')
        .replace(/<span/g, '<table class="generaltable"><tr><td')
        .replace(/<\/span>/g, '</td></tr></table>')
      : ExerciseResults;
    
    // Step 2: Remove only specific span tags (those with strikethrough and red color)
    let convertedText = formatted.replace(
      /<span style="text-decoration:line-through;color:#ff0000;">(.*?)<\/span>/g,
      '$1'
    );

    const courseIDSelected =
      localStorage.getItem('courseIdselected') &&
      localStorage.getItem('courseIdselected') !== 'undefined'
        ? localStorage.getItem('courseIdselected')
        : sessionStorage.getItem('activityInstance');
    const keyStats = getKeysStatistics(para, newText ?? text1String, keyData, instanceData);
    const keysXML = generateKeysXML(keyStats);
    convertedText = ExerciseTypes.includes(instanceData.Activities.Activity.attributes.Type)
      ? (ExerciseResults ?? theresultHTML2)
      : convertedText?.replace(/<br>/g, ' ');
    ExerciseResults = '';
    ExerciseResultsArray = [];
    const additionalInfo = instanceData.Activities.Activity.attributes.Type === 'TimedShortDrill'
      ? ` index:${currentDrillIndex} count:${text?.split('\n').length ?? 1}`
      : '';
    const xmlData = `
      <ResultXml>
          <CourseId>${courseIDSelected}</CourseId>
        <UserId>${userId}</UserId>
          <ActivityResult>
            <ActivityId>${instanceId}</ActivityId>
            <WAM>${wam}</WAM>
              <Time></Time>
            <TimeTaken>${timeTaken}</TimeTaken>
            <TotalErrors>${error}</TotalErrors>
               <UserInput><![CDATA[${text1String.replace(/⧗/g, ' ')+additionalInfo}]]></UserInput>
             <ResultText><![CDATA[${convertedText}]]></ResultText>
              <Keys>
                ${keysXML}
              </Keys>
          </ActivityResult>
      </ResultXml>
    `;
    try {
      // Make the POST request
      await axios.post(
        `${process.env.REACT_APP_MOODLE_DEVELOPMENT_URL}/mod/kb/appservice_kbws.php?action=postresult`,
        xmlData,
        {
          headers: {
            'Content-Type': 'application/xml' // Set the Content-Type header to application/xml
          }
        }
      );

      // Handle the response
      // console.log('Response:', response.data);
    } catch (error) {
      // Handle any errors
      console.error('Error:', error);
      const res = await axios({
        url: '/api/logs',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          user: userId,
          time: Date.now(),
          activity: xmlData,
          message: error,
        }
      });
    }
  };

  const TimeLimit =
    instanceData?.Activities?.Activity?.attributes?.TimeLimit ??
    instanceData?.Activities?.Activity?.Title.split('-')[0];

  const timeOpen = Number(instanceData?.Activities?.Activity?.attributes?.TimeOpen || 0);
  const timeClose = Number(instanceData?.Activities?.Activity?.attributes?.TimeClose || 0);
  const isAvalible = instanceData?.Activities?.Activity?.attributes?.Avalible;
  const restrictMessage = instanceData?.Activities?.Activity?.attributes?.RestrictReason;
  const attemptsRemainingvar = attemptsRemaining?.attributes?.AttemptsRemaining;

  const now = new Date();
  const openDate = timeOpen !== 0 ? new Date(timeOpen * 1000) : null;
  const closeDate = timeClose !== 0 ? new Date(timeClose * 1000) : null;
  let isRestricted = false;
  let accessMessage = '';

  // Restrict based on time
  if (openDate && closeDate) {
    if (now < openDate || now > closeDate) {
      isRestricted = true;
      accessMessage = `The current activity is only available after ${openDate.toLocaleString()} and before ${closeDate.toLocaleString()}.`;
    }
  } else if (openDate && now < openDate) {
    isRestricted = true;
    accessMessage = `The current activity is only available after ${openDate.toLocaleString()}.`;
  } else if (closeDate && now > closeDate) {
    isRestricted = true;
    accessMessage = `The current activity is only available before ${closeDate.toLocaleString()}.`;
  } else if (openDate == null && closeDate == null) { //if no user overrides and no open/close dates and restricted access is set
    if(isAvalible == "False") {
      isRestricted = true;
      accessMessage = restrictMessage;
    }
  } else {
    console.log("no avalibility restriction for the module");
  }



  // Restrict based on attempts
  if (attemptsRemainingvar !== '-1') {
    isRestricted = true;
    accessMessage = 'No attempts remaining for this activity.';
  }
  const [liftedNextButtonFunction, setLiftedNextButtonFunction] = useState();

  return (
    <TypingContainer
      result={result}
      title={
        instanceData
          ? `${
              instanceData.Activities.Activity && instanceData.Activities.Activity.Label
                ? instanceData.Activities.Activity.Label
                : ''
            }  ${instanceData.Activities.Activity && instanceData.Activities.Activity.Title}`
          : ''
      }
      isSentencetiming={'SentenceTiming' == instanceData?.Activities.Activity.attributes.Type}
      handleEnterEvent={handleEnterEvent}
      updateResult={submit}
      repsData={repsData}
      attributes={
        instanceData?.Activities?.Activity && instanceData?.Activities?.Activity?.attributes
          ? instanceData?.Activities?.Activity?.attributes
          : ''
      }
      showRepsDataValue={showRepsDataValue}
      type={exerciseType && exerciseType === 'Timing' ? 'Timing' : ''}
      setAutomaticSubmit={setAutomaticSubmit}
      automaticSubmit={automaticSubmit}
      counter={counter}
      setCounter={setCounter}
      TimeLimit={TimeLimit}
      text={text}
      replay={replay}
      setReplayClick={setReplayClick}
      replayClick={replayClick}
      CounterFlag={CounterFlag}
      setCounterTimeoutRefs={setCounterTimeoutRefs}>
      <TypingTestHeader
        demo={demo}
        setLiftedNextButtonFunction={setLiftedNextButtonFunction}
        setReplayClick={setReplayClick}
        replayClick={replayClick}
        instanceData={instanceData}
        setDemo={setDemo}
        setResult={setResult}
        setText={setText}
        setWordCount={setWordCount}
        setShowRepsDataValue={setShowRepsDataValue}
        setError={setError}
        setSeconds={setSeconds}
        text={text}
        setComparison={setComparison}
        result={result}
        setAllText={setAllText}
        setParagraph={setParagraph}
        TimeLimit={TimeLimit}
        setCounter={setCounter}
        setAutomaticSubmit={setAutomaticSubmit}
        wordCount={wordCount}
        exerciseType={exerciseType}
        links={links}
        curentId={InstanceId[InstanceId.length - 1]}
        wpmValue={wpmValue}
        setWpmValue={setWpmValue}
        setCounterFlag={setCounterFlag}
        setSecondflag={setSecondflag}
        setKeyData={setKeyData}
        errorValueEach={errorValueEach}
        setErrorValueEach={setErrorValueEach}
        wpmValueEach={wpmValueEach}
        setReplay={setReplay}
        counter={counter}
        setResultHTML={setResultHTML}
        setResultHTML2={setResultHTML2}
      />

      {instanceData &&
        instanceData.Activities.Activity &&
        exerciseType &&
        exerciseType !== 'Document' && (
          <div style={{ position: 'relative' }}>
            {isRestricted && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255,255,255,0.7)',
                  zIndex: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  padding: 20,
                  fontSize: 13
                }}>
                {accessMessage}
              </div>
            )}

            <div
              style={{
                pointerEvents: isRestricted ? 'none' : 'auto',
                opacity: isRestricted ? 0.5 : 1
              }}>
              <TypingTestResultFooter
                setRepsData={setRepsData}
                setReplayClick={setReplayClick}
                showRepsDataValue={showRepsDataValue}
                liftedNextButtonFunction={liftedNextButtonFunction}
                error={error}
                innitialLineCount={innitialLineCount}
                setInnitialLineCount={setInnitialLineCount}
                handleChange={handleChange}
                progress={progress}
                result={result}
                currentDrillIndex={currentDrillIndex}
                setCurrentDrillIndex={setCurrentDrillIndex}
                setResult={setResult}
                scrollDiv={scrollDiv}
                scrollResult={scrollResult}
                seconds={seconds}
                setText={setText}
                text={text}
                wordCount={wordCount}
                prgView={prgView}
                submit={submit}
                demo={demo}
                repsData={repsData}
                index={showRepsDataValue}
                comparison={comparison}
                instanceData={instanceData}
                exerciseType={exerciseType}
                submitDrill={submitDrill}
                setTextLength={setTextLength}
                handleEnterEvent={handleEnterEvent}
                theresultHTML={theresultHTML}
                theresultHTML2={theresultHTML2}
                setWpmValue={setWpmValue}
                wpmValue={wpmValue}
                setErrorValueEach={setErrorValueEach}
                allText={allText}
                keyData={keyData}
                setKeyData={setKeyData}
                wordMatch={wordMatch}
                setParagraph={setParagraph}
                TimeLimit={TimeLimit}
                counter={counter}
                setCounter={setCounter}
                attemptsRemaining={attemptsRemaining}
                setCounterTimeoutRefs={setCounterTimeoutRefs}
              />
            </div>
          </div>
        )}
    </TypingContainer>
  );
};

export default TypingTest;

export const DemoComp = ({ demo, instanceData, scrollDiv }) => {
  if (demo === false) {
    return (
      <>
        {!instanceData.Activities.Activity.attributes.Kbpath ||
        !instanceData.Activities.Activity.attributes.GraphicLocation ||
        instanceData.Activities.Activity.attributes.Kbpath === 'NA' ||
        instanceData.Activities.Activity.attributes.GraphicLocation === 'NA' ? (
          ''
        ) : (
          <img
            style={{
              maxHeight: 350,
              maxWidth: '80vw',
              borderRadius: '10px',
              boxShadow: `3px 3px 5px #BABECC,  -3px -3px 5px #BABECC`
            }}
            ref={scrollDiv}
            src={
              instanceData.Activities.Activity.attributes.Kbpath
                ? instanceData.attributes.LmsUrl +
                  instanceData.Activities.Activity.attributes.Kbpath
                : ''
            }
            alt="loading..."
          />
        )}
      </>
    );
  } else if (demo === true) {
    return (
      <>
        {!instanceData.Activities.Activity.attributes.VideoLocation ||
        !instanceData.Activities.Activity.attributes.Videopath ||
        instanceData.Activities.Activity.attributes.VideoLocation === 'NA' ||
        instanceData.Activities.Activity.attributes.Videopath === 'NA' ? (
          ''
        ) : (
          <img
            style={{
              maxHeight: 350,
              maxWidth: '80vw',
              borderRadius: '10px',
              boxShadow: `3px 3px 5px #BABECC,  -3px -3px 5px #BABECC`
            }}
            key={instanceData.Activities.Activity.attributes.Videopath}
            ref={scrollDiv}
            src={
              instanceData.Activities.Activity.attributes.Videopath
                ? instanceData.attributes.LmsUrl +
                  instanceData.Activities.Activity.attributes.Videopath
                : ''
            }
            alt="loading..."
          />
        )}
      </>
    );
  } else return '';
};
export const ButtonView = ({ result, prgView, exerciseType, submit }) => {
  const classes = useStyles();
  return (
    <Grid align="center">
      {result ? (
        prgView()
        // SJK: CKey-99: Revise condition to display submit button
        // ) : exerciseType !== 'Timing' ? (
        ) : !['Timing', 'TimingKeypadTab', 'TimingKeypadEnter'].includes(exerciseType) ? (
        <form onSubmit={submit}>
          <Button type="submit" className={classes.button} variant="outlined" onClick={submit}>
            Submit
          </Button>
        </form>
      ) : (
        <></> // Render nothing if exerciseType is 'Timing'
      )}
    </Grid>
  );
};
